import $ from "//3dhhobbies.ca/cdn/shop/t/11/assets/jquery.min.js?v=96608320211769572641759335759";

/*! Zoom 1.7.21 license: MIT http://www.jacklmoore.com/zoom */
function zoom(e) {
  const zoomer = e.currentTarget;
  let offsetX, offsetY;
  offsetX = e.offsetX ? e.offsetX : e.touches[0].pageX;
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;

  const x = offsetX / zoomer.offsetWidth * 100;
  const y = offsetY / zoomer.offsetHeight * 100;
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();
/*!Waypoints Sticky Element Shortcut - 4.0.1*/
!function(){"use strict";function t(s){this.options=e.extend({},i.defaults,t.defaults,s),this.element=this.options.element,this.$element=e(this.element),this.createWrapper(),this.createWaypoint()}var e=window.jQuery,i=window.Waypoint;t.prototype.createWaypoint=function(){var t=this.options.handler;this.waypoint=new i(e.extend({},this.options,{element:this.wrapper,handler:e.proxy(function(e){var i=this.options.direction.indexOf(e)>-1,s=i?this.$element.outerHeight(!0):"";this.$wrapper.height(s),this.$element.toggleClass(this.options.stuckClass,i),t&&t.call(this,e)},this)}))},t.prototype.createWrapper=function(){this.options.wrapper&&this.$element.wrap(this.options.wrapper),this.$wrapper=this.$element.parent(),this.wrapper=this.$wrapper[0]},t.prototype.destroy=function(){this.$element.parent()[0]===this.wrapper&&(this.waypoint.destroy(),this.$element.removeClass(this.options.stuckClass),this.options.wrapper&&this.$element.unwrap())},t.defaults={wrapper:'<div class="sticky-wrapper" />',stuckClass:"stuck",direction:"down right"},i.Sticky=t}();
/*!
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */
!function(e,i){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("jquery")):e.jQueryBridget=i(e,e.jQuery)}(window,function(t,e){"use strict";var i=Array.prototype.slice,n=t.console,d=void 0===n?function(){}:function(t){n.error(t)};function s(h,s,c){(c=c||e||t.jQuery)&&(s.prototype.option||(s.prototype.option=function(t){c.isPlainObject(t)&&(this.options=c.extend(!0,this.options,t))}),c.fn[h]=function(t){return"string"==typeof t?function(t,o,r){var a,l="$()."+h+'("'+o+'")';return t.each(function(t,e){var i=c.data(e,h);if(i){var n=i[o];if(n&&"_"!=o.charAt(0)){var s=n.apply(i,r);a=void 0===a?s:a}else d(l+" is not a valid method")}else d(h+" not initialized. Cannot call methods, i.e. "+l)}),void 0!==a?a:t}(this,t,i.call(arguments,1)):(function(t,n){t.each(function(t,e){var i=c.data(e,h);i?(i.option(n),i._init()):(i=new s(e,n),c.data(e,h,i))})}(this,t),this)},o(c))}function o(t){!t||t&&t.bridget||(t.bridget=s)}return o(e||t.jQuery),s}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],s=0;s<i.length;s++){var o=i[s];n&&n[o]&&(this.off(t,o),delete n[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function m(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var i="undefined"==typeof console?function(){}:function(t){console.error(t)},y=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],b=y.length;function E(t){var e=getComputedStyle(t);return e||i("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}var S,C=!1;function x(t){if(function(){if(!C){C=!0;var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var e=document.body||document.documentElement;e.appendChild(t);var i=E(t);S=200==Math.round(m(i.width)),x.isBoxSizeOuter=S,e.removeChild(t)}}(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var e=E(t);if("none"==e.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<b;e++){t[y[e]]=0}return t}();var i={};i.width=t.offsetWidth,i.height=t.offsetHeight;for(var n=i.isBorderBox="border-box"==e.boxSizing,s=0;s<b;s++){var o=y[s],r=e[o],a=parseFloat(r);i[o]=isNaN(a)?0:a}var l=i.paddingLeft+i.paddingRight,h=i.paddingTop+i.paddingBottom,c=i.marginLeft+i.marginRight,d=i.marginTop+i.marginBottom,u=i.borderLeftWidth+i.borderRightWidth,f=i.borderTopWidth+i.borderBottomWidth,p=n&&S,g=m(e.width);!1!==g&&(i.width=g+(p?0:l+u));var v=m(e.height);return!1!==v&&(i.height=v+(p?0:h+f)),i.innerWidth=i.width-(l+u),i.innerHeight=i.height-(h+f),i.outerWidth=i.width+c,i.outerHeight=i.height+d,i}}return x}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var i=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function(t,e){return t[i](e)}}),function(e,i){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("desandro-matches-selector")):e.fizzyUIUtils=i(e,e.matchesSelector)}(window,function(h,o){var c={extend:function(t,e){for(var i in e)t[i]=e[i];return t},modulo:function(t,e){return(t%e+e)%e}},e=Array.prototype.slice;c.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?e.call(t):[t]},c.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},c.getParent=function(t,e){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,o(t,e))return t},c.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},c.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},c.filterFindElements=function(t,n){t=c.makeArray(t);var s=[];return t.forEach(function(t){if(t instanceof HTMLElement)if(n){o(t,n)&&s.push(t);for(var e=t.querySelectorAll(n),i=0;i<e.length;i++)s.push(e[i])}else s.push(t)}),s},c.debounceMethod=function(t,e,n){n=n||100;var s=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,i=this;this[o]=setTimeout(function(){s.apply(i,e),delete i[o]},n)}},c.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},c.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var d=h.console;return c.htmlInit=function(a,l){c.docReady(function(){var t=c.toDashed(l),s="data-"+t,e=document.querySelectorAll("["+s+"]"),i=document.querySelectorAll(".js-"+t),n=c.makeArray(e).concat(c.makeArray(i)),o=s+"-options",r=h.jQuery;n.forEach(function(e){var t,i=e.getAttribute(s)||e.getAttribute(o);try{t=i&&JSON.parse(i)}catch(t){return void(d&&d.error("Error parsing "+s+" on "+e.className+": "+t))}var n=new a(e,t);r&&r.data(e,l,n)})})},c}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("get-size")):(e.Flickity=e.Flickity||{},e.Flickity.Cell=i(e,e.getSize))}(window,function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0},n.destroy=function(){this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]=""},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e=this.parent.originSide;this.element.style[e]=this.parent.getPositionValue(t)},n.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},n.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach(function(t){t.select()})},e.unselect=function(){this.cells.forEach(function(t){t.unselect()})},e.getCellElements=function(){return this.cells.map(function(t){return t.element})},t}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("fizzy-ui-utils")):(e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=i(e,e.fizzyUIUtils))}(window,function(t,e){var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame(function(){e.animate()})}},positionSlider:function(){var t=this.x;this.options.wrapAround&&1<this.cells.length&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*t)||this.restingFrames++,2<this.restingFrames&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var s=t[n],o=0<e?i:0;s.wrapShift(o),e-=s.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i}),function(r,a){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(t,e,i,n,s,o){return a(r,t,e,i,n,s,o)});else if("object"==typeof module&&module.exports)module.exports=a(r,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var t=r.Flickity;r.Flickity=a(r,r.EvEmitter,r.getSize,r.fizzyUIUtils,t.Cell,t.Slide,t.animatePrototype)}}(window,function(n,t,e,a,i,r,s){var l=n.jQuery,o=n.getComputedStyle,h=n.console;function c(t,e){for(t=a.makeArray(t);t.length;)e.appendChild(t.shift())}var d=0,u={};function f(t,e){var i=a.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){var n=u[this.element.flickityGUID];return n.option(e),n}l&&(this.$element=l(this.element)),this.options=a.extend({},this.constructor.defaults),this.option(e),this._create()}else h&&h.error("Bad element for Flickity: "+(i||t))}f.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},f.createMethods=[];var p=f.prototype;a.extend(p,t.prototype),p._create=function(){var t=this.guid=++d;for(var e in this.element.flickityGUID=t,(u[t]=this).selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&n.addEventListener("resize",this),this.options.on){var i=this.options.on[e];this.on(e,i)}f.createMethods.forEach(function(t){this[t]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(t){a.extend(this.options,t)},p.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),c(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready"))},p._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},p._filterFindCellElements=function(t){return a.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){return this._filterFindCellElements(t).map(function(t){return new i(t,this)},this)},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;if(0<t){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,s=t;s<n;s++){var o=this.cells[s];o.setPosition(e),e+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(t){t.forEach(function(t){t.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var n=new r(this);this.slides.push(n);var s="left"==this.originSide?"marginRight":"marginLeft",o=this._getCanCellFit();this.cells.forEach(function(t,e){if(n.cells.length){var i=n.outerWidth-n.firstMargin+(t.size.outerWidth-t.size[s]);o.call(this,e,i)||(n.updateTarget(),n=new r(this),this.slides.push(n)),n.addCell(t)}else n.addCell(t)},this),n.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=e(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var g={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var t=g[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},p._getGapCells=function(t,e,i){for(var n=[];0<t;){var s=this.cells[e];if(!s)break;n.push(s),e+=i,t-=s.size.outerWidth}return n},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],s=n<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[e],r=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(t){s?t.target=n*this.cellAlign:(t.target=Math.max(t.target,o),t.target=Math.min(t.target,r))},this)}},p.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),l&&this.$element){var s=t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){var o=l.Event(e);o.type=t,s=o}this.$element.trigger(s,i)}},p.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=a.modulo(t,this.slides.length)),this.slides[t])){var n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!=n&&this.dispatchEvent("change",null,[t]),this.dispatchEvent("cellSelect")}},p._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&1<e))return t;var i=a.modulo(t,e),n=Math.abs(i-this.selectedIndex),s=Math.abs(i+e-this.selectedIndex),o=Math.abs(i-e-this.selectedIndex);!this.isDragSelect&&s<n?t+=e:!this.isDragSelect&&o<n&&(t-=e),t<0?this.x-=this.slideableWidth:e<=t&&(this.x+=this.slideableWidth)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),(this.selectedSlide=t).select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectInitialIndex=function(){var t=this.options.initialIndex;if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)}},p.selectCell=function(t,e,i){var n=this.queryCell(t);if(n){var s=this.getCellSlideIndex(n);this.select(s,e,i)}},p.getCellSlideIndex=function(t){for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},p.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},p.getCells=function(t){t=a.makeArray(t);var i=[];return t.forEach(function(t){var e=this.getCell(t);e&&i.push(e)},this),i},p.getCellElements=function(){return this.cells.map(function(t){return t.element})},p.getParentCell=function(t){var e=this.getCell(t);return e||(t=a.getParent(t,".flickity-slider > *"),this.getCell(t))},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(i<=1+2*t)return this.getCellElements();for(var n=[],s=e-t;s<=e+t;s++){var o=this.options.wrapAround?a.modulo(s,i):s,r=this.slides[o];r&&(n=n.concat(r.getCellElements()))}return n},p.queryCell=function(t){if("number"==typeof t)return this.cells[t];if("string"==typeof t){if(t.match(/^[#\.]?[\d\/]/))return;t=this.element.querySelector(t)}return this.getCell(t)},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(t){"touchstart"!=t.type&&t.preventDefault(),this.focus()},p.onresize=function(){this.watchCSS(),this.resize()},a.debounceMethod(f,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=a.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},p.watchCSS=function(){this.options.watchCSS&&(-1!=o(this.element,":after").content.indexOf("flickity")?this.activate():this.deactivate())},p.onkeydown=function(t){var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=f.keyboardHandlers[t.keyCode];i&&i.call(this)}},f.keyboardHandlers={37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},p.focus=function(){var t=n.pageYOffset;this.element.focus({preventScroll:!0}),n.pageYOffset!=t&&n.scrollTo(n.pageXOffset,t)},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach(function(t){t.destroy()}),this.element.removeChild(this.viewport),c(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),n.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),l&&this.$element&&l.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete u[this.guid]},a.extend(p,s),f.data=function(t){var e=(t=a.getQueryElement(t))&&t.flickityGUID;return e&&u[e]},a.htmlInit(f,"flickity"),l&&l.bridget&&l.bridget("flickity",f),f.setJQuery=function(t){l=t},f.Cell=i,f.Slide=r,f}),function(e,i){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.Unipointer=i(e,e.EvEmitter)}(window,function(s,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindStartEvent=function(t){this._bindStartEvent(t,!0)},i.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},i._bindStartEvent=function(t,e){var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n="mousedown";s.PointerEvent?n="pointerdown":"ontouchstart"in s&&(n="touchstart"),t[i](n,this)},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},i.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},i.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},i.onpointerdown=function(t){this._pointerDown(t,t)},i._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},i.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var n={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return i._bindPostStartEvents=function(t){if(t){var e=n[t.type];e.forEach(function(t){s.addEventListener(t,this)},this),this._boundPointerEvents=e}},i._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(t){s.removeEventListener(t,this)},this),delete this._boundPointerEvents)},i.onmousemove=function(t){this._pointerMove(t,t)},i.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},i.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},i._pointerMove=function(t,e){this.pointerMove(t,e)},i.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},i.onmouseup=function(t){this._pointerUp(t,t)},i.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},i.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},i._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},i._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},i._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},i.pointerDone=function(){},i.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},i.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},i._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},i.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},e.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},e}),function(e,i){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("unipointer")):e.Unidragger=i(e,e.Unipointer)}(window,function(o,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},i._bindHandles=function(t){for(var e=(t=void 0===t||t)?"addEventListener":"removeEventListener",i=t?this._touchActionValue:"",n=0;n<this.handles.length;n++){var s=this.handles[n];this._bindStartEvent(s,t),s[e]("click",this),o.PointerEvent&&(s.style.touchAction=i)}},i._touchActionValue="none",i.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer=e,t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var s={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return i.okayPointerDown=function(t){var e=s[t.target.nodeName],i=r[t.target.type],n=!e||i;return n||this._pointerReset(),n},i.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},i.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},i._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},i.hasDragStarted=function(t){return 3<Math.abs(t.x)||3<Math.abs(t.y)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},i._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},i._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},i.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},i._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},i.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},i._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},i.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},i.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},i._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},e.getPointerPoint=t.getPointerPoint,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):n.Flickity=s(n,n.Flickity,n.Unidragger,n.fizzyUIUtils)}(window,function(i,t,e,a){a.extend(t.defaults,{draggable:">1",dragThreshold:3}),t.createMethods.push("_createDrag");var n=t.prototype;a.extend(n,e.prototype),n._touchActionValue="pan-y";var s="createTouch"in document,o=!1;n._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),s&&!o&&(i.addEventListener("touchmove",function(){}),o=!0)},n.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},n.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},n.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=1<this.slides.length:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},n.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},n.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},n._uiChangeDrag=function(){delete this.isFreeScrolling},n.pointerDown=function(t,e){this.isDraggable?this.okayPointerDown(t)&&(this._pointerDownPreventDefault(t),this.pointerDownFocus(t),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=l(),i.addEventListener("scroll",this),this._pointerDownDefault(t,e)):this._pointerDownDefault(t,e)},n._pointerDownDefault=function(t,e){this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var r={INPUT:!0,TEXTAREA:!0,SELECT:!0};function l(){return{x:i.pageXOffset,y:i.pageYOffset}}return n.pointerDownFocus=function(t){r[t.target.nodeName]||this.focus()},n._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=r[t.target.nodeName];e||i||n||t.preventDefault()},n.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},n.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},n.pointerDone=function(){i.removeEventListener("scroll",this),delete this.pointerDownScroll},n.dragStart=function(t,e){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),i.removeEventListener("scroll",this),this.dispatchEvent("dragStart",t,[e]))},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},n.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(i.x=i.x%this.slideableWidth);var s=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var o=Math.max(-this.slides[0].target,this.dragStartPosition);s=o<s?.5*(s+o):s;var r=Math.min(-this.getLastSlide().target,this.dragStartPosition);s=s<r?.5*(s+r):s}this.dragX=s,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},n.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},n.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);return i.distance<n.distance?i.index:n.index},n._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,s=1/0,o=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};o(e,s)&&(n+=i,s=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:s,index:n-i}},n.getSlideDistance=function(t,e){var i=this.slides.length,n=this.options.wrapAround&&1<i,s=n?a.modulo(e,i):e,o=this.slides[s];if(!o)return null;var r=n?this.slideableWidth*Math.floor(e/i):0;return t-(o.target+r)},n.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||100<new Date-this.dragMoveTime)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return 0<t&&0<e?1:t<0&&e<0?-1:0},n.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,s=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,s])},n.onscroll=function(){var t=l(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(3<Math.abs(e)||3<Math.abs(i))&&this._pointerDone()},t}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){"use strict";var s="http://www.w3.org/2000/svg";function o(t,e){this.direction=t,this.parent=e,this._create()}(o.prototype=Object.create(i.prototype))._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},o.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},o.prototype.createSVG=function(){var t=document.createElementNS(s,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(s,"path"),i=function(t){return"string"!=typeof t?"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z":t}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},o.prototype.handleEvent=n.handleEvent,o.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},o.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},o.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},o.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&1<t.length)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var r=e.prototype;return r._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new o(-1,this),this.nextButton=new o(1,this),this.on("activate",this.activatePrevNextButtons))},r.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},r.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=o,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){function s(t){this.parent=t,this._create()}(s.prototype=Object.create(i.prototype))._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},s.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},s.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},s.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;0<t?this.addDots(t):t<0&&this.removeDots(-t)},s.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,s=n+t,o=n;o<s;o++){var r=document.createElement("li");r.className="dot",r.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(r),i.push(r)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},s.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach(function(t){this.holder.removeChild(t)},this)},s.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},s.prototype.onTap=s.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},s.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=s,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var o=e.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new s(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=s,e}),function(t,n){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(t,e,i){return n(t,e,i)}):"object"==typeof module&&module.exports?module.exports=n(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):n(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,function(t,e,i){function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}(n.prototype=Object.create(t.prototype)).play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout(function(){e.parent.next(!0),e.tick()},t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var s=i.prototype;return s._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},s.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},s.playPlayer=function(){this.player.play()},s.stopPlayer=function(){this.player.stop()},s.pausePlayer=function(){this.player.pause()},s.unpausePlayer=function(){this.player.unpause()},s.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},s.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},s.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,n){var i=e.prototype;return i.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var s=function(t){var e=document.createDocumentFragment();return t.forEach(function(t){e.appendChild(t.element)}),e}(i),o=e==n;if(o)this.slider.appendChild(s);else{var r=this.cells[e].element;this.slider.insertBefore(s,r)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},i.append=function(t){this.insert(t,this.cells.length)},i.prepend=function(t){this.insert(t,0)},i.remove=function(t){var e=this.getCells(t);if(e&&e.length){var i=this.cells.length-1;e.forEach(function(t){t.remove();var e=this.cells.indexOf(t);i=Math.min(e,i),n.removeFrom(this.cells,t)},this),this.cellChange(i,!0)}},i.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},i.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,o){"use strict";e.createMethods.push("_createLazyload");var i=e.prototype;function s(t,e){this.img=t,this.flickity=e,this.load()}return i._createLazyload=function(){this.on("select",this.lazyLoad)},i.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,i=this.getAdjacentCellElements(e),n=[];i.forEach(function(t){var e=function(t){if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),i=t.getAttribute("data-flickity-lazyload-src"),n=t.getAttribute("data-flickity-lazyload-srcset");if(e||i||n)return[t]}var s=t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");return o.makeArray(s)}(t);n=n.concat(e)}),n.forEach(function(t){new s(t,this)},this)}},s.prototype.handleEvent=o.handleEvent,s.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=t,e&&this.img.setAttribute("srcset",e),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},s.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},s.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},s.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=s,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(t){return t}),function(t,e){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):t.Flickity=e(t.Flickity,t.fizzyUIUtils)}(window,function(n,s){n.createMethods.push("_createAsNavFor");var t=n.prototype;return t._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var t=this.options.asNavFor;if(t){var e=this;setTimeout(function(){e.setNavCompanion(t)})}},t.setNavCompanion=function(t){t=s.getQueryElement(t);var e=n.data(t);if(e&&e!=this){this.navCompanion=e;var i=this;this.onNavCompanionSelect=function(){i.navCompanionSelect()},e.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},t.navCompanionSelect=function(t){var e=this.navCompanion&&this.navCompanion.selectedCells;if(e){var i=e[0],n=this.navCompanion.cells.indexOf(i),s=n+e.length-1,o=Math.floor(function(t,e,i){return(e-t)*i+t}(n,s,this.navCompanion.cellAlign));if(this.selectCell(o,!1,t),this.removeNavSelectedElements(),!(o>=this.cells.length)){var r=this.cells.slice(n,1+s);this.navSelectedElements=r.map(function(t){return t.element}),this.changeNavSelectedClass("add")}}},t.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},t.activateAsNavFor=function(){this.navCompanionSelect(!0)},t.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},t.onNavStaticClick=function(t,e,i,n){"number"==typeof n&&this.navCompanion.selectCell(n)},t.deactivateAsNavFor=function(){this.removeNavSelectedElements()},t.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},n}),function(e,i){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.imagesLoaded=i(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){var s=e.jQuery,o=e.console;function r(t,e){for(var i in e)t[i]=e[i];return t}var a=Array.prototype.slice;function l(t,e,i){if(!(this instanceof l))return new l(t,e,i);var n=t;"string"==typeof t&&(n=document.querySelectorAll(t)),n?(this.elements=function(t){return Array.isArray(t)?t:"object"==typeof t&&"number"==typeof t.length?a.call(t):[t]}(n),this.options=r({},this.options),"function"==typeof e?i=e:r(this.options,e),i&&this.on("always",i),this.getImages(),s&&(this.jqDeferred=new s.Deferred),setTimeout(this.check.bind(this))):o.error("Bad element for imagesLoaded "+(n||t))}(l.prototype=Object.create(t.prototype)).options={},l.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},l.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&h[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var s=i[n];this.addImage(s)}if("string"==typeof this.options.background){var o=t.querySelectorAll(this.options.background);for(n=0;n<o.length;n++){var r=o[n];this.addElementBackgroundImages(r)}}}};var h={1:!0,9:!0,11:!0};function i(t){this.img=t}function n(t,e){this.url=t,this.element=e,this.img=new Image}return l.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var s=n&&n[2];s&&this.addBackground(s,t),n=i.exec(e.backgroundImage)}},l.prototype.addImage=function(t){var e=new i(t);this.images.push(e)},l.prototype.addBackground=function(t,e){var i=new n(t,e);this.images.push(i)},l.prototype.check=function(){var n=this;function e(t,e,i){setTimeout(function(){n.progress(t,e,i)})}this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?this.images.forEach(function(t){t.once("progress",e),t.check()}):this.complete()},l.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&o&&o.log("progress: "+i,t,e)},l.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},(i.prototype=Object.create(t.prototype)).check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.src)},i.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},i.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},i.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},i.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},i.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},(n.prototype=Object.create(i.prototype)).check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},n.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},n.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},l.makeJQueryPlugin=function(t){(t=t||e.jQuery)&&((s=t).fn.imagesLoaded=function(t,e){return new l(this,t,e).jqDeferred.promise(s(this))})},l.makeJQueryPlugin(),l}),function(i,n){"function"==typeof define&&define.amd?define(["flickity/js/index","imagesloaded/imagesloaded"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("flickity"),require("imagesloaded")):i.Flickity=n(i,i.Flickity,i.imagesLoaded)}(window,function(t,e,i){"use strict";e.createMethods.push("_createImagesLoaded");var n=e.prototype;return n._createImagesLoaded=function(){this.on("activate",this.imagesLoaded)},n.imagesLoaded=function(){if(this.options.imagesLoaded){var n=this;i(this.slider).on("progress",function(t,e){var i=n.getParentCell(e.img);n.cellSizeChange(i&&i.element),n.options.freeScroll||n.positionSliderAtSelected()})}},e});
// wishlist, comparelist
function productsCookieList(t){let e=$.extend({type:"vndWslst",btnClass:".btn-wishlist",listItem:".wishlist-card",listCount:".wishlist-count",listGrid:".wishlist-grid",pageClass:".page-wishlist",removeAll:".clear-wishlist",ajaxTarget:"?view=wishlist_item_html"},t);const s=$(e.btnClass),i=($(e.listItem),$(e.listCount));let l=localStorage.getItem(e.type)||[];l.length>0&&(l=JSON.parse(l));const a=function(t){const s=t.dataset.productHandle;if(s){const i=$(t).hasClass("is-active"),a=t.querySelector("span");if(i){a&&(a.innerText=t.title);const i=l.indexOf(s);l.splice(i,1),localStorage.setItem(e.type,JSON.stringify(l))}else a&&(a.innerText=t.dataset.removeTitle),l.push(s),localStorage.setItem(e.type,JSON.stringify(l));n()}},n=function(){i.text(l.length),l.length>0?i.show():$(".header").find(i).hide()};s.click(function(t){t.preventDefault(),a(this),$(this).toggleClass("is-active")}),s.each(function(){const t=this.dataset.productHandle;if(l.indexOf(t)>-1){const t=this.querySelector("span");t&&(t.innerText=this.dataset.removeTitle),$(this).addClass("is-active")}}),$(e.pageClass).length>0&&(function(){const t="grid-items__"+$(e.listGrid).data("grid-items");for(let s=0;s<l.length;s++){const i=l[s];$.ajax({url:"/products/"+i+e.ajaxTarget,dataType:"HTML",type:"GET",success:function(s){if("?view=wishlist_item_html"==e.ajaxTarget){const i=(new DOMParser).parseFromString(s,"text/html").querySelector(".wishlist-card");$(e.listGrid).append(i),$(e.listGrid).find(e.listItem).addClass(t),i.querySelector(e.btnClass).onclick=function(t){t.preventDefault(),a(this),this.closest(e.listItem).remove()}}else{const t=(new DOMParser).parseFromString(s,"text/html");for(let s=1;s<7;s++){const i=".compare-item__"+s,l=t.querySelector(i);l.classList.remove("compare-item__"+s),$(e.listGrid).find(i).append(l),1==s&&(l.querySelector(e.btnClass).onclick=function(t){t.preventDefault(),a(this),$(e.listGrid).find("[data-product-handle="+this.dataset.productHandle+"]").remove()})}}}})}l.length<1?($(e.removeAll).hide(250),$(".page-list__empty").addClass("is-visible")):($(".page-list__empty").removeClass("is-visible"),$(e.removeAll).css("display","flex"))}(),setTimeout(function(){$(".result-loading").removeClass("active"),l.length>0&&$(e.listGrid).addClass("is-visible")},500)),n(),$(e.removeAll).click(function(t){t.preventDefault(),l=[],localStorage.setItem(e.type,JSON.stringify(l)),$(e.listItem).slideUp("slow",()=>{this.remove(),n()})})}
/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});
/*!Waypoints Infinite Scroll Shortcut - 4.0.1*/
!function(){"use strict";function t(n){this.options=i.extend({},t.defaults,n),this.container=this.options.element,"auto"!==this.options.container&&(this.container=this.options.container),this.$container=i(this.container),this.$more=i(this.options.more),this.$more.length&&(this.setupHandler(),this.waypoint=new o(this.options))}var i=window.jQuery,o=window.Waypoint;t.prototype.setupHandler=function(){this.options.handler=i.proxy(function(){this.options.onBeforePageLoad(),this.destroy(),this.$container.addClass(this.options.loadingClass),i.get(i(this.options.more).attr("href"),i.proxy(function(t){var n=i(i.parseHTML(t)),e=n.find(this.options.more),s=n.find(this.options.items);s.length||(s=n.filter(this.options.items)),this.$container.append(s),this.$container.removeClass(this.options.loadingClass),e.length||(e=n.filter(this.options.more)),e.length?(this.$more.replaceWith(e),this.$more=e,this.waypoint=new o(this.options)):this.$more.remove(),this.options.onAfterPageLoad(s)},this))},this)},t.prototype.destroy=function(){this.waypoint&&this.waypoint.destroy()},t.defaults={container:"auto",items:".infinite-item",more:".infinite-more-link",offset:"bottom-in-view",loadingClass:"infinite-loading",onBeforePageLoad:i.noop,onAfterPageLoad:i.noop},o.Infinite=t}();
/*!Waypoints Inview Shortcut - 4.0.1*/
!function(){"use strict";function t(){}var e=window.Waypoint;function i(t){this.options=e.Adapter.extend({},i.defaults,t),this.axis=this.options.horizontal?"horizontal":"vertical",this.waypoints=[],this.element=this.options.element,this.createWaypoints()}i.prototype.createWaypoints=function(){function t(t){var e=t.offsetHeight,i=getComputedStyle(t);return e+=parseInt(i.marginTop)+parseInt(i.marginBottom)}for(var e={vertical:[{down:"enter",up:"exited",offset:function(){var t=this.options.offset&&this.options.offset.bottom||0;return this.options.context.innerHeight-t}.bind(this)},{down:"entered",up:"exit",offset:function(){var e=this.options.offset&&this.options.offset.bottom||0;return this.options.context.innerHeight-t(this.element)-e}.bind(this)},{down:"exit",up:"entered",offset:function(){return this.options.offset&&this.options.offset.top||0}.bind(this)},{down:"exited",up:"enter",offset:function(){return(this.options.offset&&this.options.offset.top||0)-t(this.element)}.bind(this)}],horizontal:[{right:"enter",left:"exited",offset:"100%"},{right:"entered",left:"exit",offset:"right-in-view"},{right:"exit",left:"entered",offset:0},{right:"exited",left:"enter",offset:function(){return-this.adapter.outerWidth()}}]},i=0,o=e[this.axis].length;i<o;i++){var n=e[this.axis][i];this.createWaypoint(n)}},i.prototype.createWaypoint=function(t){var i=this;this.waypoints.push(new e({context:this.options.context,element:this.options.element,enabled:this.options.enabled,handler:function(t){return function(e){i.options[t[e]].call(i,e)}}(t),offset:t.offset,horizontal:this.options.horizontal}))},i.prototype.destroy=function(){for(var t=0,e=this.waypoints.length;t<e;t++)this.waypoints[t].destroy();this.waypoints=[]},i.prototype.disable=function(){for(var t=0,e=this.waypoints.length;t<e;t++)this.waypoints[t].disable()},i.prototype.enable=function(){for(var t=0,e=this.waypoints.length;t<e;t++)this.waypoints[t].enable()},i.defaults={context:window,enabled:!0,enter:t,entered:t,exit:t,exited:t},e.Inview=i}();
/*enable sync for Flickity*/
!function(t,n){"function"==typeof define&&define.amd?define(["flickity/js/index","fizzy-ui-utils/utils"],n):"object"==typeof module&&module.exports?module.exports=n(require("flickity"),require("fizzy-ui-utils")):t.Flickity=n(t.Flickity,t.fizzyUIUtils)}(window,function(t,n){"use strict";return t.createMethods.push("_createSync"),t.prototype._createSync=function(){this.syncers={};var t=this.options.sync;if(this.on("destroy",this.unsyncAll),t){var n=this;setTimeout(function(){n.sync(t)})}},t.prototype.sync=function(i){i=n.getQueryElement(i);var e=t.data(i);e&&(this._syncCompanion(e),e._syncCompanion(this))},t.prototype._syncCompanion=function(t){var n=this;function i(){var i=n.selectedIndex;t.selectedIndex!=i&&t.select(i)}this.on("select",i),this.syncers[t.guid]={flickity:t,listener:i}},t.prototype.unsync=function(i){i=n.getQueryElement(i);var e=t.data(i);this._unsync(e)},t.prototype._unsync=function(t){t&&(this._unsyncCompanion(t),t._unsyncCompanion(this))},t.prototype._unsyncCompanion=function(t){var n=t.guid,i=this.syncers[n];this.off("select",i.listener),delete this.syncers[n]},t.prototype.unsyncAll=function(){for(var t in this.syncers){var n=this.syncers[t];this._unsync(n.flickity)}},t});
/*!
 * Isotope PACKAGED v3.0.6
 *
 * Licensed GPLv3 for open source use
 * or Isotope Commercial License for commercial use
 *
 * https://isotope.metafizzy.co
 * Copyright 2010-2018 Metafizzy
 */
!function(t,e){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("jquery")):t.jQueryBridget=e(t,t.jQuery)}(window,function(t,e){"use strict";function i(i,s,a){function u(t,e,o){var n,s="$()."+i+'("'+e+'")';return t.each(function(t,u){var h=a.data(u,i);if(!h)return void r(i+" not initialized. Cannot call methods, i.e. "+s);var d=h[e];if(!d||"_"==e.charAt(0))return void r(s+" is not a valid method");var l=d.apply(h,o);n=void 0===n?l:n}),void 0!==n?n:t}function h(t,e){t.each(function(t,o){var n=a.data(o,i);n?(n.option(e),n._init()):(n=new s(o,e),a.data(o,i,n))})}a=a||e||t.jQuery,a&&(s.prototype.option||(s.prototype.option=function(t){a.isPlainObject(t)&&(this.options=a.extend(!0,this.options,t))}),a.fn[i]=function(t){if("string"==typeof t){var e=n.call(arguments,1);return u(this,t,e)}return h(this,t),this},o(a))}function o(t){!t||t&&t.bridget||(t.bridget=i)}var n=Array.prototype.slice,s=t.console,r="undefined"==typeof s?function(){}:function(t){s.error(t)};return o(e||t.jQuery),i}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},o=i[t]=i[t]||[];return o.indexOf(e)==-1&&o.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},o=i[t]=i[t]||{};return o[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var o=i.indexOf(e);return o!=-1&&i.splice(o,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var o=this._onceEvents&&this._onceEvents[t],n=0;n<i.length;n++){var s=i[n],r=o&&o[s];r&&(this.off(t,s),delete o[s]),s.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function t(t){var e=parseFloat(t),i=t.indexOf("%")==-1&&!isNaN(e);return i&&e}function e(){}function i(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<h;e++){var i=u[e];t[i]=0}return t}function o(t){var e=getComputedStyle(t);return e||a("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}function n(){if(!d){d=!0;var e=document.createElement("div");e.style.width="200px",e.style.padding="1px 2px 3px 4px",e.style.borderStyle="solid",e.style.borderWidth="1px 2px 3px 4px",e.style.boxSizing="border-box";var i=document.body||document.documentElement;i.appendChild(e);var n=o(e);r=200==Math.round(t(n.width)),s.isBoxSizeOuter=r,i.removeChild(e)}}function s(e){if(n(),"string"==typeof e&&(e=document.querySelector(e)),e&&"object"==typeof e&&e.nodeType){var s=o(e);if("none"==s.display)return i();var a={};a.width=e.offsetWidth,a.height=e.offsetHeight;for(var d=a.isBorderBox="border-box"==s.boxSizing,l=0;l<h;l++){var f=u[l],c=s[f],m=parseFloat(c);a[f]=isNaN(m)?0:m}var p=a.paddingLeft+a.paddingRight,y=a.paddingTop+a.paddingBottom,g=a.marginLeft+a.marginRight,v=a.marginTop+a.marginBottom,_=a.borderLeftWidth+a.borderRightWidth,z=a.borderTopWidth+a.borderBottomWidth,I=d&&r,x=t(s.width);x!==!1&&(a.width=x+(I?0:p+_));var S=t(s.height);return S!==!1&&(a.height=S+(I?0:y+z)),a.innerWidth=a.width-(p+_),a.innerHeight=a.height-(y+z),a.outerWidth=a.width+g,a.outerHeight=a.height+v,a}}var r,a="undefined"==typeof console?e:function(t){console.error(t)},u=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],h=u.length,d=!1;return s}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var t=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var o=e[i],n=o+"MatchesSelector";if(t[n])return n}}();return function(e,i){return e[t](i)}}),function(t,e){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("desandro-matches-selector")):t.fizzyUIUtils=e(t,t.matchesSelector)}(window,function(t,e){var i={};i.extend=function(t,e){for(var i in e)t[i]=e[i];return t},i.modulo=function(t,e){return(t%e+e)%e};var o=Array.prototype.slice;i.makeArray=function(t){if(Array.isArray(t))return t;if(null===t||void 0===t)return[];var e="object"==typeof t&&"number"==typeof t.length;return e?o.call(t):[t]},i.removeFrom=function(t,e){var i=t.indexOf(e);i!=-1&&t.splice(i,1)},i.getParent=function(t,i){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,e(t,i))return t},i.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.filterFindElements=function(t,o){t=i.makeArray(t);var n=[];return t.forEach(function(t){if(t instanceof HTMLElement){if(!o)return void n.push(t);e(t,o)&&n.push(t);for(var i=t.querySelectorAll(o),s=0;s<i.length;s++)n.push(i[s])}}),n},i.debounceMethod=function(t,e,i){i=i||100;var o=t.prototype[e],n=e+"Timeout";t.prototype[e]=function(){var t=this[n];clearTimeout(t);var e=arguments,s=this;this[n]=setTimeout(function(){o.apply(s,e),delete s[n]},i)}},i.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},i.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var n=t.console;return i.htmlInit=function(e,o){i.docReady(function(){var s=i.toDashed(o),r="data-"+s,a=document.querySelectorAll("["+r+"]"),u=document.querySelectorAll(".js-"+s),h=i.makeArray(a).concat(i.makeArray(u)),d=r+"-options",l=t.jQuery;h.forEach(function(t){var i,s=t.getAttribute(r)||t.getAttribute(d);try{i=s&&JSON.parse(s)}catch(a){return void(n&&n.error("Error parsing "+r+" on "+t.className+": "+a))}var u=new e(t,i);l&&l.data(t,o,u)})})},i}),function(t,e){"function"==typeof define&&define.amd?define("outlayer/item",["ev-emitter/ev-emitter","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("ev-emitter"),require("get-size")):(t.Outlayer={},t.Outlayer.Item=e(t.EvEmitter,t.getSize))}(window,function(t,e){"use strict";function i(t){for(var e in t)return!1;return e=null,!0}function o(t,e){t&&(this.element=t,this.layout=e,this.position={x:0,y:0},this._create())}function n(t){return t.replace(/([A-Z])/g,function(t){return"-"+t.toLowerCase()})}var s=document.documentElement.style,r="string"==typeof s.transition?"transition":"WebkitTransition",a="string"==typeof s.transform?"transform":"WebkitTransform",u={WebkitTransition:"webkitTransitionEnd",transition:"transitionend"}[r],h={transform:a,transition:r,transitionDuration:r+"Duration",transitionProperty:r+"Property",transitionDelay:r+"Delay"},d=o.prototype=Object.create(t.prototype);d.constructor=o,d._create=function(){this._transn={ingProperties:{},clean:{},onEnd:{}},this.css({position:"absolute"})},d.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},d.getSize=function(){this.size=e(this.element)},d.css=function(t){var e=this.element.style;for(var i in t){var o=h[i]||i;e[o]=t[i]}},d.getPosition=function(){var t=getComputedStyle(this.element),e=this.layout._getOption("originLeft"),i=this.layout._getOption("originTop"),o=t[e?"left":"right"],n=t[i?"top":"bottom"],s=parseFloat(o),r=parseFloat(n),a=this.layout.size;o.indexOf("%")!=-1&&(s=s/100*a.width),n.indexOf("%")!=-1&&(r=r/100*a.height),s=isNaN(s)?0:s,r=isNaN(r)?0:r,s-=e?a.paddingLeft:a.paddingRight,r-=i?a.paddingTop:a.paddingBottom,this.position.x=s,this.position.y=r},d.layoutPosition=function(){var t=this.layout.size,e={},i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop"),n=i?"paddingLeft":"paddingRight",s=i?"left":"right",r=i?"right":"left",a=this.position.x+t[n];e[s]=this.getXValue(a),e[r]="";var u=o?"paddingTop":"paddingBottom",h=o?"top":"bottom",d=o?"bottom":"top",l=this.position.y+t[u];e[h]=this.getYValue(l),e[d]="",this.css(e),this.emitEvent("layout",[this])},d.getXValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&!e?t/this.layout.size.width*100+"%":t+"px"},d.getYValue=function(t){var e=this.layout._getOption("horizontal");return this.layout.options.percentPosition&&e?t/this.layout.size.height*100+"%":t+"px"},d._transitionTo=function(t,e){this.getPosition();var i=this.position.x,o=this.position.y,n=t==this.position.x&&e==this.position.y;if(this.setPosition(t,e),n&&!this.isTransitioning)return void this.layoutPosition();var s=t-i,r=e-o,a={};a.transform=this.getTranslate(s,r),this.transition({to:a,onTransitionEnd:{transform:this.layoutPosition},isCleaning:!0})},d.getTranslate=function(t,e){var i=this.layout._getOption("originLeft"),o=this.layout._getOption("originTop");return t=i?t:-t,e=o?e:-e,"translate3d("+t+"px, "+e+"px, 0)"},d.goTo=function(t,e){this.setPosition(t,e),this.layoutPosition()},d.moveTo=d._transitionTo,d.setPosition=function(t,e){this.position.x=parseFloat(t),this.position.y=parseFloat(e)},d._nonTransition=function(t){this.css(t.to),t.isCleaning&&this._removeStyles(t.to);for(var e in t.onTransitionEnd)t.onTransitionEnd[e].call(this)},d.transition=function(t){if(!parseFloat(this.layout.options.transitionDuration))return void this._nonTransition(t);var e=this._transn;for(var i in t.onTransitionEnd)e.onEnd[i]=t.onTransitionEnd[i];for(i in t.to)e.ingProperties[i]=!0,t.isCleaning&&(e.clean[i]=!0);if(t.from){this.css(t.from);var o=this.element.offsetHeight;o=null}this.enableTransition(t.to),this.css(t.to),this.isTransitioning=!0};var l="opacity,"+n(a);d.enableTransition=function(){if(!this.isTransitioning){var t=this.layout.options.transitionDuration;t="number"==typeof t?t+"ms":t,this.css({transitionProperty:l,transitionDuration:t,transitionDelay:this.staggerDelay||0}),this.element.addEventListener(u,this,!1)}},d.onwebkitTransitionEnd=function(t){this.ontransitionend(t)},d.onotransitionend=function(t){this.ontransitionend(t)};var f={"-webkit-transform":"transform"};d.ontransitionend=function(t){if(t.target===this.element){var e=this._transn,o=f[t.propertyName]||t.propertyName;if(delete e.ingProperties[o],i(e.ingProperties)&&this.disableTransition(),o in e.clean&&(this.element.style[t.propertyName]="",delete e.clean[o]),o in e.onEnd){var n=e.onEnd[o];n.call(this),delete e.onEnd[o]}this.emitEvent("transitionEnd",[this])}},d.disableTransition=function(){this.removeTransitionStyles(),this.element.removeEventListener(u,this,!1),this.isTransitioning=!1},d._removeStyles=function(t){var e={};for(var i in t)e[i]="";this.css(e)};var c={transitionProperty:"",transitionDuration:"",transitionDelay:""};return d.removeTransitionStyles=function(){this.css(c)},d.stagger=function(t){t=isNaN(t)?0:t,this.staggerDelay=t+"ms"},d.removeElem=function(){this.element.parentNode.removeChild(this.element),this.css({display:""}),this.emitEvent("remove",[this])},d.remove=function(){return r&&parseFloat(this.layout.options.transitionDuration)?(this.once("transitionEnd",function(){this.removeElem()}),void this.hide()):void this.removeElem()},d.reveal=function(){delete this.isHidden,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("visibleStyle");e[i]=this.onRevealTransitionEnd,this.transition({from:t.hiddenStyle,to:t.visibleStyle,isCleaning:!0,onTransitionEnd:e})},d.onRevealTransitionEnd=function(){this.isHidden||this.emitEvent("reveal")},d.getHideRevealTransitionEndProperty=function(t){var e=this.layout.options[t];if(e.opacity)return"opacity";for(var i in e)return i},d.hide=function(){this.isHidden=!0,this.css({display:""});var t=this.layout.options,e={},i=this.getHideRevealTransitionEndProperty("hiddenStyle");e[i]=this.onHideTransitionEnd,this.transition({from:t.visibleStyle,to:t.hiddenStyle,isCleaning:!0,onTransitionEnd:e})},d.onHideTransitionEnd=function(){this.isHidden&&(this.css({display:"none"}),this.emitEvent("hide"))},d.destroy=function(){this.css({position:"",left:"",right:"",top:"",bottom:"",transition:"",transform:""})},o}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("outlayer/outlayer",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./item"],function(i,o,n,s){return e(t,i,o,n,s)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./item")):t.Outlayer=e(t,t.EvEmitter,t.getSize,t.fizzyUIUtils,t.Outlayer.Item)}(window,function(t,e,i,o,n){"use strict";function s(t,e){var i=o.getQueryElement(t);if(!i)return void(u&&u.error("Bad element for "+this.constructor.namespace+": "+(i||t)));this.element=i,h&&(this.$element=h(this.element)),this.options=o.extend({},this.constructor.defaults),this.option(e);var n=++l;this.element.outlayerGUID=n,f[n]=this,this._create();var s=this._getOption("initLayout");s&&this.layout()}function r(t){function e(){t.apply(this,arguments)}return e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e}function a(t){if("number"==typeof t)return t;var e=t.match(/(^\d*\.?\d*)(\w*)/),i=e&&e[1],o=e&&e[2];if(!i.length)return 0;i=parseFloat(i);var n=m[o]||1;return i*n}var u=t.console,h=t.jQuery,d=function(){},l=0,f={};s.namespace="outlayer",s.Item=n,s.defaults={containerStyle:{position:"relative"},initLayout:!0,originLeft:!0,originTop:!0,resize:!0,resizeContainer:!0,transitionDuration:"0.4s",hiddenStyle:{opacity:0,transform:"scale(0.001)"},visibleStyle:{opacity:1,transform:"scale(1)"}};var c=s.prototype;o.extend(c,e.prototype),c.option=function(t){o.extend(this.options,t)},c._getOption=function(t){var e=this.constructor.compatOptions[t];return e&&void 0!==this.options[e]?this.options[e]:this.options[t]},s.compatOptions={initLayout:"isInitLayout",horizontal:"isHorizontal",layoutInstant:"isLayoutInstant",originLeft:"isOriginLeft",originTop:"isOriginTop",resize:"isResizeBound",resizeContainer:"isResizingContainer"},c._create=function(){this.reloadItems(),this.stamps=[],this.stamp(this.options.stamp),o.extend(this.element.style,this.options.containerStyle);var t=this._getOption("resize");t&&this.bindResize()},c.reloadItems=function(){this.items=this._itemize(this.element.children)},c._itemize=function(t){for(var e=this._filterFindItemElements(t),i=this.constructor.Item,o=[],n=0;n<e.length;n++){var s=e[n],r=new i(s,this);o.push(r)}return o},c._filterFindItemElements=function(t){return o.filterFindElements(t,this.options.itemSelector)},c.getItemElements=function(){return this.items.map(function(t){return t.element})},c.layout=function(){this._resetLayout(),this._manageStamps();var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;this.layoutItems(this.items,e),this._isLayoutInited=!0},c._init=c.layout,c._resetLayout=function(){this.getSize()},c.getSize=function(){this.size=i(this.element)},c._getMeasurement=function(t,e){var o,n=this.options[t];n?("string"==typeof n?o=this.element.querySelector(n):n instanceof HTMLElement&&(o=n),this[t]=o?i(o)[e]:n):this[t]=0},c.layoutItems=function(t,e){t=this._getItemsForLayout(t),this._layoutItems(t,e),this._postLayout()},c._getItemsForLayout=function(t){return t.filter(function(t){return!t.isIgnored})},c._layoutItems=function(t,e){if(this._emitCompleteOnItems("layout",t),t&&t.length){var i=[];t.forEach(function(t){var o=this._getItemLayoutPosition(t);o.item=t,o.isInstant=e||t.isLayoutInstant,i.push(o)},this),this._processLayoutQueue(i)}},c._getItemLayoutPosition=function(){return{x:0,y:0}},c._processLayoutQueue=function(t){this.updateStagger(),t.forEach(function(t,e){this._positionItem(t.item,t.x,t.y,t.isInstant,e)},this)},c.updateStagger=function(){var t=this.options.stagger;return null===t||void 0===t?void(this.stagger=0):(this.stagger=a(t),this.stagger)},c._positionItem=function(t,e,i,o,n){o?t.goTo(e,i):(t.stagger(n*this.stagger),t.moveTo(e,i))},c._postLayout=function(){this.resizeContainer()},c.resizeContainer=function(){var t=this._getOption("resizeContainer");if(t){var e=this._getContainerSize();e&&(this._setContainerMeasure(e.width,!0),this._setContainerMeasure(e.height,!1))}},c._getContainerSize=d,c._setContainerMeasure=function(t,e){if(void 0!==t){var i=this.size;i.isBorderBox&&(t+=e?i.paddingLeft+i.paddingRight+i.borderLeftWidth+i.borderRightWidth:i.paddingBottom+i.paddingTop+i.borderTopWidth+i.borderBottomWidth),t=Math.max(t,0),this.element.style[e?"width":"height"]=t+"px"}},c._emitCompleteOnItems=function(t,e){function i(){n.dispatchEvent(t+"Complete",null,[e])}function o(){r++,r==s&&i()}var n=this,s=e.length;if(!e||!s)return void i();var r=0;e.forEach(function(e){e.once(t,o)})},c.dispatchEvent=function(t,e,i){var o=e?[e].concat(i):i;if(this.emitEvent(t,o),h)if(this.$element=this.$element||h(this.element),e){var n=h.Event(e);n.type=t,this.$element.trigger(n,i)}else this.$element.trigger(t,i)},c.ignore=function(t){var e=this.getItem(t);e&&(e.isIgnored=!0)},c.unignore=function(t){var e=this.getItem(t);e&&delete e.isIgnored},c.stamp=function(t){t=this._find(t),t&&(this.stamps=this.stamps.concat(t),t.forEach(this.ignore,this))},c.unstamp=function(t){t=this._find(t),t&&t.forEach(function(t){o.removeFrom(this.stamps,t),this.unignore(t)},this)},c._find=function(t){if(t)return"string"==typeof t&&(t=this.element.querySelectorAll(t)),t=o.makeArray(t)},c._manageStamps=function(){this.stamps&&this.stamps.length&&(this._getBoundingRect(),this.stamps.forEach(this._manageStamp,this))},c._getBoundingRect=function(){var t=this.element.getBoundingClientRect(),e=this.size;this._boundingRect={left:t.left+e.paddingLeft+e.borderLeftWidth,top:t.top+e.paddingTop+e.borderTopWidth,right:t.right-(e.paddingRight+e.borderRightWidth),bottom:t.bottom-(e.paddingBottom+e.borderBottomWidth)}},c._manageStamp=d,c._getElementOffset=function(t){var e=t.getBoundingClientRect(),o=this._boundingRect,n=i(t),s={left:e.left-o.left-n.marginLeft,top:e.top-o.top-n.marginTop,right:o.right-e.right-n.marginRight,bottom:o.bottom-e.bottom-n.marginBottom};return s},c.handleEvent=o.handleEvent,c.bindResize=function(){t.addEventListener("resize",this),this.isResizeBound=!0},c.unbindResize=function(){t.removeEventListener("resize",this),this.isResizeBound=!1},c.onresize=function(){this.resize()},o.debounceMethod(s,"onresize",100),c.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&this.layout()},c.needsResizeLayout=function(){var t=i(this.element),e=this.size&&t;return e&&t.innerWidth!==this.size.innerWidth},c.addItems=function(t){var e=this._itemize(t);return e.length&&(this.items=this.items.concat(e)),e},c.appended=function(t){var e=this.addItems(t);e.length&&(this.layoutItems(e,!0),this.reveal(e))},c.prepended=function(t){var e=this._itemize(t);if(e.length){var i=this.items.slice(0);this.items=e.concat(i),this._resetLayout(),this._manageStamps(),this.layoutItems(e,!0),this.reveal(e),this.layoutItems(i)}},c.reveal=function(t){if(this._emitCompleteOnItems("reveal",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.reveal()})}},c.hide=function(t){if(this._emitCompleteOnItems("hide",t),t&&t.length){var e=this.updateStagger();t.forEach(function(t,i){t.stagger(i*e),t.hide()})}},c.revealItemElements=function(t){var e=this.getItems(t);this.reveal(e)},c.hideItemElements=function(t){var e=this.getItems(t);this.hide(e)},c.getItem=function(t){for(var e=0;e<this.items.length;e++){var i=this.items[e];if(i.element==t)return i}},c.getItems=function(t){t=o.makeArray(t);var e=[];return t.forEach(function(t){var i=this.getItem(t);i&&e.push(i)},this),e},c.remove=function(t){var e=this.getItems(t);this._emitCompleteOnItems("remove",e),e&&e.length&&e.forEach(function(t){t.remove(),o.removeFrom(this.items,t)},this)},c.destroy=function(){var t=this.element.style;t.height="",t.position="",t.width="",this.items.forEach(function(t){t.destroy()}),this.unbindResize();var e=this.element.outlayerGUID;delete f[e],delete this.element.outlayerGUID,h&&h.removeData(this.element,this.constructor.namespace)},s.data=function(t){t=o.getQueryElement(t);var e=t&&t.outlayerGUID;return e&&f[e]},s.create=function(t,e){var i=r(s);return i.defaults=o.extend({},s.defaults),o.extend(i.defaults,e),i.compatOptions=o.extend({},s.compatOptions),i.namespace=t,i.data=s.data,i.Item=r(n),o.htmlInit(i,t),h&&h.bridget&&h.bridget(t,i),i};var m={ms:1,s:1e3};return s.Item=n,s}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/item",["outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.Item=e(t.Outlayer))}(window,function(t){"use strict";function e(){t.Item.apply(this,arguments)}var i=e.prototype=Object.create(t.Item.prototype),o=i._create;i._create=function(){this.id=this.layout.itemGUID++,o.call(this),this.sortData={}},i.updateSortData=function(){if(!this.isIgnored){this.sortData.id=this.id,this.sortData["original-order"]=this.id,this.sortData.random=Math.random();var t=this.layout.options.getSortData,e=this.layout._sorters;for(var i in t){var o=e[i];this.sortData[i]=o(this.element,this)}}};var n=i.destroy;return i.destroy=function(){n.apply(this,arguments),this.css({display:""})},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-mode",["get-size/get-size","outlayer/outlayer"],e):"object"==typeof module&&module.exports?module.exports=e(require("get-size"),require("outlayer")):(t.Isotope=t.Isotope||{},t.Isotope.LayoutMode=e(t.getSize,t.Outlayer))}(window,function(t,e){"use strict";function i(t){this.isotope=t,t&&(this.options=t.options[this.namespace],this.element=t.element,this.items=t.filteredItems,this.size=t.size)}var o=i.prototype,n=["_resetLayout","_getItemLayoutPosition","_manageStamp","_getContainerSize","_getElementOffset","needsResizeLayout","_getOption"];return n.forEach(function(t){o[t]=function(){return e.prototype[t].apply(this.isotope,arguments)}}),o.needsVerticalResizeLayout=function(){var e=t(this.isotope.element),i=this.isotope.size&&e;return i&&e.innerHeight!=this.isotope.size.innerHeight},o._getMeasurement=function(){this.isotope._getMeasurement.apply(this,arguments)},o.getColumnWidth=function(){this.getSegmentSize("column","Width")},o.getRowHeight=function(){this.getSegmentSize("row","Height")},o.getSegmentSize=function(t,e){var i=t+e,o="outer"+e;if(this._getMeasurement(i,o),!this[i]){var n=this.getFirstItemSize();this[i]=n&&n[o]||this.isotope.size["inner"+e]}},o.getFirstItemSize=function(){var e=this.isotope.filteredItems[0];return e&&e.element&&t(e.element)},o.layout=function(){this.isotope.layout.apply(this.isotope,arguments)},o.getSize=function(){this.isotope.getSize(),this.size=this.isotope.size},i.modes={},i.create=function(t,e){function n(){i.apply(this,arguments)}return n.prototype=Object.create(o),n.prototype.constructor=n,e&&(n.options=e),n.prototype.namespace=t,i.modes[t]=n,n},i}),function(t,e){"function"==typeof define&&define.amd?define("masonry-layout/masonry",["outlayer/outlayer","get-size/get-size"],e):"object"==typeof module&&module.exports?module.exports=e(require("outlayer"),require("get-size")):t.Masonry=e(t.Outlayer,t.getSize)}(window,function(t,e){var i=t.create("masonry");i.compatOptions.fitWidth="isFitWidth";var o=i.prototype;return o._resetLayout=function(){this.getSize(),this._getMeasurement("columnWidth","outerWidth"),this._getMeasurement("gutter","outerWidth"),this.measureColumns(),this.colYs=[];for(var t=0;t<this.cols;t++)this.colYs.push(0);this.maxY=0,this.horizontalColIndex=0},o.measureColumns=function(){if(this.getContainerWidth(),!this.columnWidth){var t=this.items[0],i=t&&t.element;this.columnWidth=i&&e(i).outerWidth||this.containerWidth}var o=this.columnWidth+=this.gutter,n=this.containerWidth+this.gutter,s=n/o,r=o-n%o,a=r&&r<1?"round":"floor";s=Math[a](s),this.cols=Math.max(s,1)},o.getContainerWidth=function(){var t=this._getOption("fitWidth"),i=t?this.element.parentNode:this.element,o=e(i);this.containerWidth=o&&o.innerWidth},o._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth%this.columnWidth,i=e&&e<1?"round":"ceil",o=Math[i](t.size.outerWidth/this.columnWidth);o=Math.min(o,this.cols);for(var n=this.options.horizontalOrder?"_getHorizontalColPosition":"_getTopColPosition",s=this[n](o,t),r={x:this.columnWidth*s.col,y:s.y},a=s.y+t.size.outerHeight,u=o+s.col,h=s.col;h<u;h++)this.colYs[h]=a;return r},o._getTopColPosition=function(t){var e=this._getTopColGroup(t),i=Math.min.apply(Math,e);return{col:e.indexOf(i),y:i}},o._getTopColGroup=function(t){if(t<2)return this.colYs;for(var e=[],i=this.cols+1-t,o=0;o<i;o++)e[o]=this._getColGroupY(o,t);return e},o._getColGroupY=function(t,e){if(e<2)return this.colYs[t];var i=this.colYs.slice(t,t+e);return Math.max.apply(Math,i)},o._getHorizontalColPosition=function(t,e){var i=this.horizontalColIndex%this.cols,o=t>1&&i+t>this.cols;i=o?0:i;var n=e.size.outerWidth&&e.size.outerHeight;return this.horizontalColIndex=n?i+t:this.horizontalColIndex,{col:i,y:this._getColGroupY(i,t)}},o._manageStamp=function(t){var i=e(t),o=this._getElementOffset(t),n=this._getOption("originLeft"),s=n?o.left:o.right,r=s+i.outerWidth,a=Math.floor(s/this.columnWidth);a=Math.max(0,a);var u=Math.floor(r/this.columnWidth);u-=r%this.columnWidth?0:1,u=Math.min(this.cols-1,u);for(var h=this._getOption("originTop"),d=(h?o.top:o.bottom)+i.outerHeight,l=a;l<=u;l++)this.colYs[l]=Math.max(d,this.colYs[l])},o._getContainerSize=function(){this.maxY=Math.max.apply(Math,this.colYs);var t={height:this.maxY};return this._getOption("fitWidth")&&(t.width=this._getContainerFitWidth()),t},o._getContainerFitWidth=function(){for(var t=0,e=this.cols;--e&&0===this.colYs[e];)t++;return(this.cols-t)*this.columnWidth-this.gutter},o.needsResizeLayout=function(){var t=this.containerWidth;return this.getContainerWidth(),t!=this.containerWidth},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/masonry",["../layout-mode","masonry-layout/masonry"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode"),require("masonry-layout")):e(t.Isotope.LayoutMode,t.Masonry)}(window,function(t,e){"use strict";var i=t.create("masonry"),o=i.prototype,n={_getElementOffset:!0,layout:!0,_getMeasurement:!0};for(var s in e.prototype)n[s]||(o[s]=e.prototype[s]);var r=o.measureColumns;o.measureColumns=function(){this.items=this.isotope.filteredItems,r.call(this)};var a=o._getOption;return o._getOption=function(t){return"fitWidth"==t?void 0!==this.options.isFitWidth?this.options.isFitWidth:this.options.fitWidth:a.apply(this.isotope,arguments)},i}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/fit-rows",["../layout-mode"],e):"object"==typeof exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("fitRows"),i=e.prototype;return i._resetLayout=function(){this.x=0,this.y=0,this.maxY=0,this._getMeasurement("gutter","outerWidth")},i._getItemLayoutPosition=function(t){t.getSize();var e=t.size.outerWidth+this.gutter,i=this.isotope.size.innerWidth+this.gutter;0!==this.x&&e+this.x>i&&(this.x=0,this.y=this.maxY);var o={x:this.x,y:this.y};return this.maxY=Math.max(this.maxY,this.y+t.size.outerHeight),this.x+=e,o},i._getContainerSize=function(){return{height:this.maxY}},e}),function(t,e){"function"==typeof define&&define.amd?define("isotope-layout/js/layout-modes/vertical",["../layout-mode"],e):"object"==typeof module&&module.exports?module.exports=e(require("../layout-mode")):e(t.Isotope.LayoutMode)}(window,function(t){"use strict";var e=t.create("vertical",{horizontalAlignment:0}),i=e.prototype;return i._resetLayout=function(){this.y=0},i._getItemLayoutPosition=function(t){t.getSize();var e=(this.isotope.size.innerWidth-t.size.outerWidth)*this.options.horizontalAlignment,i=this.y;return this.y+=t.size.outerHeight,{x:e,y:i}},i._getContainerSize=function(){return{height:this.y}},e}),function(t,e){"function"==typeof define&&define.amd?define(["outlayer/outlayer","get-size/get-size","desandro-matches-selector/matches-selector","fizzy-ui-utils/utils","isotope-layout/js/item","isotope-layout/js/layout-mode","isotope-layout/js/layout-modes/masonry","isotope-layout/js/layout-modes/fit-rows","isotope-layout/js/layout-modes/vertical"],function(i,o,n,s,r,a){return e(t,i,o,n,s,r,a)}):"object"==typeof module&&module.exports?module.exports=e(t,require("outlayer"),require("get-size"),require("desandro-matches-selector"),require("fizzy-ui-utils"),require("isotope-layout/js/item"),require("isotope-layout/js/layout-mode"),require("isotope-layout/js/layout-modes/masonry"),require("isotope-layout/js/layout-modes/fit-rows"),require("isotope-layout/js/layout-modes/vertical")):t.Isotope=e(t,t.Outlayer,t.getSize,t.matchesSelector,t.fizzyUIUtils,t.Isotope.Item,t.Isotope.LayoutMode)}(window,function(t,e,i,o,n,s,r){function a(t,e){return function(i,o){for(var n=0;n<t.length;n++){var s=t[n],r=i.sortData[s],a=o.sortData[s];if(r>a||r<a){var u=void 0!==e[s]?e[s]:e,h=u?1:-1;return(r>a?1:-1)*h}}return 0}}var u=t.jQuery,h=String.prototype.trim?function(t){return t.trim()}:function(t){return t.replace(/^\s+|\s+$/g,"")},d=e.create("isotope",{layoutMode:"masonry",isJQueryFiltering:!0,sortAscending:!0});d.Item=s,d.LayoutMode=r;var l=d.prototype;l._create=function(){this.itemGUID=0,this._sorters={},this._getSorters(),e.prototype._create.call(this),this.modes={},this.filteredItems=this.items,this.sortHistory=["original-order"];for(var t in r.modes)this._initLayoutMode(t)},l.reloadItems=function(){this.itemGUID=0,e.prototype.reloadItems.call(this)},l._itemize=function(){for(var t=e.prototype._itemize.apply(this,arguments),i=0;i<t.length;i++){var o=t[i];o.id=this.itemGUID++}return this._updateItemsSortData(t),t},l._initLayoutMode=function(t){var e=r.modes[t],i=this.options[t]||{};this.options[t]=e.options?n.extend(e.options,i):i,this.modes[t]=new e(this)},l.layout=function(){return!this._isLayoutInited&&this._getOption("initLayout")?void this.arrange():void this._layout()},l._layout=function(){var t=this._getIsInstant();this._resetLayout(),this._manageStamps(),this.layoutItems(this.filteredItems,t),this._isLayoutInited=!0},l.arrange=function(t){this.option(t),this._getIsInstant();var e=this._filter(this.items);this.filteredItems=e.matches,this._bindArrangeComplete(),this._isInstant?this._noTransition(this._hideReveal,[e]):this._hideReveal(e),this._sort(),this._layout()},l._init=l.arrange,l._hideReveal=function(t){this.reveal(t.needReveal),this.hide(t.needHide)},l._getIsInstant=function(){var t=this._getOption("layoutInstant"),e=void 0!==t?t:!this._isLayoutInited;return this._isInstant=e,e},l._bindArrangeComplete=function(){function t(){e&&i&&o&&n.dispatchEvent("arrangeComplete",null,[n.filteredItems])}var e,i,o,n=this;this.once("layoutComplete",function(){e=!0,t()}),this.once("hideComplete",function(){i=!0,t()}),this.once("revealComplete",function(){o=!0,t()})},l._filter=function(t){var e=this.options.filter;e=e||"*";for(var i=[],o=[],n=[],s=this._getFilterTest(e),r=0;r<t.length;r++){var a=t[r];if(!a.isIgnored){var u=s(a);u&&i.push(a),u&&a.isHidden?o.push(a):u||a.isHidden||n.push(a)}}return{matches:i,needReveal:o,needHide:n}},l._getFilterTest=function(t){return u&&this.options.isJQueryFiltering?function(e){return u(e.element).is(t);
}:"function"==typeof t?function(e){return t(e.element)}:function(e){return o(e.element,t)}},l.updateSortData=function(t){var e;t?(t=n.makeArray(t),e=this.getItems(t)):e=this.items,this._getSorters(),this._updateItemsSortData(e)},l._getSorters=function(){var t=this.options.getSortData;for(var e in t){var i=t[e];this._sorters[e]=f(i)}},l._updateItemsSortData=function(t){for(var e=t&&t.length,i=0;e&&i<e;i++){var o=t[i];o.updateSortData()}};var f=function(){function t(t){if("string"!=typeof t)return t;var i=h(t).split(" "),o=i[0],n=o.match(/^\[(.+)\]$/),s=n&&n[1],r=e(s,o),a=d.sortDataParsers[i[1]];return t=a?function(t){return t&&a(r(t))}:function(t){return t&&r(t)}}function e(t,e){return t?function(e){return e.getAttribute(t)}:function(t){var i=t.querySelector(e);return i&&i.textContent}}return t}();d.sortDataParsers={parseInt:function(t){return parseInt(t,10)},parseFloat:function(t){return parseFloat(t)}},l._sort=function(){if(this.options.sortBy){var t=n.makeArray(this.options.sortBy);this._getIsSameSortBy(t)||(this.sortHistory=t.concat(this.sortHistory));var e=a(this.sortHistory,this.options.sortAscending);this.filteredItems.sort(e)}},l._getIsSameSortBy=function(t){for(var e=0;e<t.length;e++)if(t[e]!=this.sortHistory[e])return!1;return!0},l._mode=function(){var t=this.options.layoutMode,e=this.modes[t];if(!e)throw new Error("No layout mode: "+t);return e.options=this.options[t],e},l._resetLayout=function(){e.prototype._resetLayout.call(this),this._mode()._resetLayout()},l._getItemLayoutPosition=function(t){return this._mode()._getItemLayoutPosition(t)},l._manageStamp=function(t){this._mode()._manageStamp(t)},l._getContainerSize=function(){return this._mode()._getContainerSize()},l.needsResizeLayout=function(){return this._mode().needsResizeLayout()},l.appended=function(t){var e=this.addItems(t);if(e.length){var i=this._filterRevealAdded(e);this.filteredItems=this.filteredItems.concat(i)}},l.prepended=function(t){var e=this._itemize(t);if(e.length){this._resetLayout(),this._manageStamps();var i=this._filterRevealAdded(e);this.layoutItems(this.filteredItems),this.filteredItems=i.concat(this.filteredItems),this.items=e.concat(this.items)}},l._filterRevealAdded=function(t){var e=this._filter(t);return this.hide(e.needHide),this.reveal(e.matches),this.layoutItems(e.matches,!0),e.matches},l.insert=function(t){var e=this.addItems(t);if(e.length){var i,o,n=e.length;for(i=0;i<n;i++)o=e[i],this.element.appendChild(o.element);var s=this._filter(e).matches;for(i=0;i<n;i++)e[i].isLayoutInstant=!0;for(this.arrange(),i=0;i<n;i++)delete e[i].isLayoutInstant;this.reveal(s)}};var c=l.remove;return l.remove=function(t){t=n.makeArray(t);var e=this.getItems(t);c.call(this,t);for(var i=e&&e.length,o=0;i&&o<i;o++){var s=e[o];n.removeFrom(this.filteredItems,s)}},l.shuffle=function(){for(var t=0;t<this.items.length;t++){var e=this.items[t];e.sortData.random=Math.random()}this.options.sortBy="random",this._sort(),this._layout()},l._noTransition=function(t,e){var i=this.options.transitionDuration;this.options.transitionDuration=0;var o=t.apply(this,e);return this.options.transitionDuration=i,o},l.getFilteredItemElements=function(){return this.filteredItems.map(function(t){return t.element})},d});
/*!
 * Packery layout mode PACKAGED v2.0.1
 * sub-classes Packery
 */
!function(a,b){"function"==typeof define&&define.amd?define("packery/js/rect",b):"object"==typeof module&&module.exports?module.exports=b():(a.Packery=a.Packery||{},a.Packery.Rect=b())}(window,function(){function a(b){for(var c in a.defaults)this[c]=a.defaults[c];for(c in b)this[c]=b[c]}a.defaults={x:0,y:0,width:0,height:0};var b=a.prototype;return b.contains=function(a){var b=a.width||0,c=a.height||0;return this.x<=a.x&&this.y<=a.y&&this.x+this.width>=a.x+b&&this.y+this.height>=a.y+c},b.overlaps=function(a){var b=this.x+this.width,c=this.y+this.height,d=a.x+a.width,e=a.y+a.height;return this.x<d&&b>a.x&&this.y<e&&c>a.y},b.getMaximalFreeRects=function(b){if(!this.overlaps(b))return!1;var c,d=[],e=this.x+this.width,f=this.y+this.height,g=b.x+b.width,h=b.y+b.height;return this.y<b.y&&(c=new a({x:this.x,y:this.y,width:this.width,height:b.y-this.y}),d.push(c)),e>g&&(c=new a({x:g,y:this.y,width:e-g,height:this.height}),d.push(c)),f>h&&(c=new a({x:this.x,y:h,width:this.width,height:f-h}),d.push(c)),this.x<b.x&&(c=new a({x:this.x,y:this.y,width:b.x-this.x,height:this.height}),d.push(c)),d},b.canFit=function(a){return this.width>=a.width&&this.height>=a.height},a}),function(a,b){if("function"==typeof define&&define.amd)define("packery/js/packer",["./rect"],b);else if("object"==typeof module&&module.exports)module.exports=b(require("./rect"));else{var c=a.Packery=a.Packery||{};c.Packer=b(c.Rect)}}(window,function(a){function b(a,b,c){this.width=a||0,this.height=b||0,this.sortDirection=c||"downwardLeftToRight",this.reset()}var c=b.prototype;c.reset=function(){this.spaces=[];var b=new a({x:0,y:0,width:this.width,height:this.height});this.spaces.push(b),this.sorter=d[this.sortDirection]||d.downwardLeftToRight},c.pack=function(a){for(var b=0;b<this.spaces.length;b++){var c=this.spaces[b];if(c.canFit(a)){this.placeInSpace(a,c);break}}},c.columnPack=function(a){for(var b=0;b<this.spaces.length;b++){var c=this.spaces[b],d=c.x<=a.x&&c.x+c.width>=a.x+a.width&&c.height>=a.height-.01;if(d){a.y=c.y,this.placed(a);break}}},c.rowPack=function(a){for(var b=0;b<this.spaces.length;b++){var c=this.spaces[b],d=c.y<=a.y&&c.y+c.height>=a.y+a.height&&c.width>=a.width-.01;if(d){a.x=c.x,this.placed(a);break}}},c.placeInSpace=function(a,b){a.x=b.x,a.y=b.y,this.placed(a)},c.placed=function(a){for(var b=[],c=0;c<this.spaces.length;c++){var d=this.spaces[c],e=d.getMaximalFreeRects(a);e?b.push.apply(b,e):b.push(d)}this.spaces=b,this.mergeSortSpaces()},c.mergeSortSpaces=function(){b.mergeRects(this.spaces),this.spaces.sort(this.sorter)},c.addSpace=function(a){this.spaces.push(a),this.mergeSortSpaces()},b.mergeRects=function(a){var b=0,c=a[b];a:for(;c;){for(var d=0,e=a[b+d];e;){if(e==c)d++;else{if(e.contains(c)){a.splice(b,1),c=a[b];continue a}c.contains(e)?a.splice(b+d,1):d++}e=a[b+d]}b++,c=a[b]}return a};var d={downwardLeftToRight:function(a,b){return a.y-b.y||a.x-b.x},rightwardTopToBottom:function(a,b){return a.x-b.x||a.y-b.y}};return b}),function(a,b){"function"==typeof define&&define.amd?define("packery/js/item",["outlayer/outlayer","./rect"],b):"object"==typeof module&&module.exports?module.exports=b(require("outlayer"),require("./rect")):a.Packery.Item=b(a.Outlayer,a.Packery.Rect)}(window,function(a,b){var c=document.documentElement.style,d="string"==typeof c.transform?"transform":"WebkitTransform",e=function(){a.Item.apply(this,arguments)},f=e.prototype=Object.create(a.Item.prototype),g=f._create;f._create=function(){g.call(this),this.rect=new b};var h=f.moveTo;return f.moveTo=function(a,b){var c=Math.abs(this.position.x-a),d=Math.abs(this.position.y-b),e=this.layout.dragItemCount&&!this.isPlacing&&!this.isTransitioning&&1>c&&1>d;return e?void this.goTo(a,b):void h.apply(this,arguments)},f.enablePlacing=function(){this.removeTransitionStyles(),this.isTransitioning&&d&&(this.element.style[d]="none"),this.isTransitioning=!1,this.getSize(),this.layout._setRectSize(this.element,this.rect),this.isPlacing=!0},f.disablePlacing=function(){this.isPlacing=!1},f.removeElem=function(){this.element.parentNode.removeChild(this.element),this.layout.packer.addSpace(this.rect),this.emitEvent("remove",[this])},f.showDropPlaceholder=function(){var a=this.dropPlaceholder;a||(a=this.dropPlaceholder=document.createElement("div"),a.className="packery-drop-placeholder",a.style.position="absolute"),a.style.width=this.size.width+"px",a.style.height=this.size.height+"px",this.positionDropPlaceholder(),this.layout.element.appendChild(a)},f.positionDropPlaceholder=function(){this.dropPlaceholder.style[d]="translate("+this.rect.x+"px, "+this.rect.y+"px)"},f.hideDropPlaceholder=function(){this.layout.element.removeChild(this.dropPlaceholder)},e}),function(a,b){"function"==typeof define&&define.amd?define("packery/js/packery",["get-size/get-size","outlayer/outlayer","./rect","./packer","./item"],b):"object"==typeof module&&module.exports?module.exports=b(require("get-size"),require("outlayer"),require("./rect"),require("./packer"),require("./item")):a.Packery=b(a.getSize,a.Outlayer,a.Packery.Rect,a.Packery.Packer,a.Packery.Item)}(window,function(a,b,c,d,e){function f(a,b){return a.position.y-b.position.y||a.position.x-b.position.x}function g(a,b){return a.position.x-b.position.x||a.position.y-b.position.y}function h(a,b){var c=b.x-a.x,d=b.y-a.y;return Math.sqrt(c*c+d*d)}c.prototype.canFit=function(a){return this.width>=a.width-1&&this.height>=a.height-1};var i=b.create("packery");i.Item=e;var j=i.prototype;j._create=function(){b.prototype._create.call(this),this.packer=new d,this.shiftPacker=new d,this.isEnabled=!0,this.dragItemCount=0;var a=this;this.handleDraggabilly={dragStart:function(){a.itemDragStart(this.element)},dragMove:function(){a.itemDragMove(this.element,this.position.x,this.position.y)},dragEnd:function(){a.itemDragEnd(this.element)}},this.handleUIDraggable={start:function(b,c){c&&a.itemDragStart(b.currentTarget)},drag:function(b,c){c&&a.itemDragMove(b.currentTarget,c.position.left,c.position.top)},stop:function(b,c){c&&a.itemDragEnd(b.currentTarget)}}},j._resetLayout=function(){this.getSize(),this._getMeasurements();var a,b,c;this._getOption("horizontal")?(a=1/0,b=this.size.innerHeight+this.gutter,c="rightwardTopToBottom"):(a=this.size.innerWidth+this.gutter,b=1/0,c="downwardLeftToRight"),this.packer.width=this.shiftPacker.width=a,this.packer.height=this.shiftPacker.height=b,this.packer.sortDirection=this.shiftPacker.sortDirection=c,this.packer.reset(),this.maxY=0,this.maxX=0},j._getMeasurements=function(){this._getMeasurement("columnWidth","width"),this._getMeasurement("rowHeight","height"),this._getMeasurement("gutter","width")},j._getItemLayoutPosition=function(a){if(this._setRectSize(a.element,a.rect),this.isShifting||this.dragItemCount>0){var b=this._getPackMethod();this.packer[b](a.rect)}else this.packer.pack(a.rect);return this._setMaxXY(a.rect),a.rect},j.shiftLayout=function(){this.isShifting=!0,this.layout(),delete this.isShifting},j._getPackMethod=function(){return this._getOption("horizontal")?"rowPack":"columnPack"},j._setMaxXY=function(a){this.maxX=Math.max(a.x+a.width,this.maxX),this.maxY=Math.max(a.y+a.height,this.maxY)},j._setRectSize=function(b,c){var d=a(b),e=d.outerWidth,f=d.outerHeight;(e||f)&&(e=this._applyGridGutter(e,this.columnWidth),f=this._applyGridGutter(f,this.rowHeight)),c.width=Math.min(e,this.packer.width),c.height=Math.min(f,this.packer.height)},j._applyGridGutter=function(a,b){if(!b)return a+this.gutter;b+=this.gutter;var c=a%b,d=c&&1>c?"round":"ceil";return a=Math[d](a/b)*b},j._getContainerSize=function(){return this._getOption("horizontal")?{width:this.maxX-this.gutter}:{height:this.maxY-this.gutter}},j._manageStamp=function(a){var b,d=this.getItem(a);if(d&&d.isPlacing)b=d.rect;else{var e=this._getElementOffset(a);b=new c({x:this._getOption("originLeft")?e.left:e.right,y:this._getOption("originTop")?e.top:e.bottom})}this._setRectSize(a,b),this.packer.placed(b),this._setMaxXY(b)},j.sortItemsByPosition=function(){var a=this._getOption("horizontal")?g:f;this.items.sort(a)},j.fit=function(a,b,c){var d=this.getItem(a);d&&(this.stamp(d.element),d.enablePlacing(),this.updateShiftTargets(d),b=void 0===b?d.rect.x:b,c=void 0===c?d.rect.y:c,this.shift(d,b,c),this._bindFitEvents(d),d.moveTo(d.rect.x,d.rect.y),this.shiftLayout(),this.unstamp(d.element),this.sortItemsByPosition(),d.disablePlacing())},j._bindFitEvents=function(a){function b(){d++,2==d&&c.dispatchEvent("fitComplete",null,[a])}var c=this,d=0;a.once("layout",b),this.once("layoutComplete",b)},j.resize=function(){this.isResizeBound&&this.needsResizeLayout()&&(this.options.shiftPercentResize?this.resizeShiftPercentLayout():this.layout())},j.needsResizeLayout=function(){var b=a(this.element),c=this._getOption("horizontal")?"innerHeight":"innerWidth";return b[c]!=this.size[c]},j.resizeShiftPercentLayout=function(){var b=this._getItemsForLayout(this.items),c=this._getOption("horizontal"),d=c?"y":"x",e=c?"height":"width",f=c?"rowHeight":"columnWidth",g=c?"innerHeight":"innerWidth",h=this[f];if(h=h&&h+this.gutter){this._getMeasurements();var i=this[f]+this.gutter;b.forEach(function(a){var b=Math.round(a.rect[d]/h);a.rect[d]=b*i})}else{var j=a(this.element)[g]+this.gutter,k=this.packer[e];b.forEach(function(a){a.rect[d]=a.rect[d]/k*j})}this.shiftLayout()},j.itemDragStart=function(a){if(this.isEnabled){this.stamp(a);var b=this.getItem(a);b&&(b.enablePlacing(),b.showDropPlaceholder(),this.dragItemCount++,this.updateShiftTargets(b))}},j.updateShiftTargets=function(a){this.shiftPacker.reset(),this._getBoundingRect();var b=this._getOption("originLeft"),d=this._getOption("originTop");this.stamps.forEach(function(a){var e=this.getItem(a);if(!e||!e.isPlacing){var f=this._getElementOffset(a),g=new c({x:b?f.left:f.right,y:d?f.top:f.bottom});this._setRectSize(a,g),this.shiftPacker.placed(g)}},this);var e=this._getOption("horizontal"),f=e?"rowHeight":"columnWidth",g=e?"height":"width";this.shiftTargetKeys=[],this.shiftTargets=[];var h,i=this[f];if(i=i&&i+this.gutter){var j=Math.ceil(a.rect[g]/i),k=Math.floor((this.shiftPacker[g]+this.gutter)/i);h=(k-j)*i;for(var l=0;k>l;l++)this._addShiftTarget(l*i,0,h)}else h=this.shiftPacker[g]+this.gutter-a.rect[g],this._addShiftTarget(0,0,h);var m=this._getItemsForLayout(this.items),n=this._getPackMethod();m.forEach(function(a){var b=a.rect;this._setRectSize(a.element,b),this.shiftPacker[n](b),this._addShiftTarget(b.x,b.y,h);var c=e?b.x+b.width:b.x,d=e?b.y:b.y+b.height;if(this._addShiftTarget(c,d,h),i)for(var f=Math.round(b[g]/i),j=1;f>j;j++){var k=e?c:b.x+i*j,l=e?b.y+i*j:d;this._addShiftTarget(k,l,h)}},this)},j._addShiftTarget=function(a,b,c){var d=this._getOption("horizontal")?b:a;if(!(0!==d&&d>c)){var e=a+","+b,f=-1!=this.shiftTargetKeys.indexOf(e);f||(this.shiftTargetKeys.push(e),this.shiftTargets.push({x:a,y:b}))}},j.shift=function(a,b,c){var d,e=1/0,f={x:b,y:c};this.shiftTargets.forEach(function(a){var b=h(a,f);e>b&&(d=a,e=b)}),a.rect.x=d.x,a.rect.y=d.y};var k=120;j.itemDragMove=function(a,b,c){function d(){f.shift(e,b,c),e.positionDropPlaceholder(),f.layout()}var e=this.isEnabled&&this.getItem(a);if(e){b-=this.size.paddingLeft,c-=this.size.paddingTop;var f=this,g=new Date;this._itemDragTime&&g-this._itemDragTime<k?(clearTimeout(this.dragTimeout),this.dragTimeout=setTimeout(d,k)):(d(),this._itemDragTime=g)}},j.itemDragEnd=function(a){function b(){d++,2==d&&(c.element.classList.remove("is-positioning-post-drag"),c.hideDropPlaceholder(),e.dispatchEvent("dragItemPositioned",null,[c]))}var c=this.isEnabled&&this.getItem(a);if(c){clearTimeout(this.dragTimeout),c.element.classList.add("is-positioning-post-drag");var d=0,e=this;c.once("layout",b),this.once("layoutComplete",b),c.moveTo(c.rect.x,c.rect.y),this.layout(),this.dragItemCount=Math.max(0,this.dragItemCount-1),this.sortItemsByPosition(),c.disablePlacing(),this.unstamp(c.element)}},j.bindDraggabillyEvents=function(a){this._bindDraggabillyEvents(a,"on")},j.unbindDraggabillyEvents=function(a){this._bindDraggabillyEvents(a,"off")},j._bindDraggabillyEvents=function(a,b){var c=this.handleDraggabilly;a[b]("dragStart",c.dragStart),a[b]("dragMove",c.dragMove),a[b]("dragEnd",c.dragEnd)},j.bindUIDraggableEvents=function(a){this._bindUIDraggableEvents(a,"on")},j.unbindUIDraggableEvents=function(a){this._bindUIDraggableEvents(a,"off")},j._bindUIDraggableEvents=function(a,b){var c=this.handleUIDraggable;a[b]("dragstart",c.start)[b]("drag",c.drag)[b]("dragstop",c.stop)};var l=j.destroy;return j.destroy=function(){l.apply(this,arguments),this.isEnabled=!1},i.Rect=c,i.Packer=d,i}),function(a,b){"function"==typeof define&&define.amd?define(["isotope-layout/js/layout-mode","packery/js/packery"],b):"object"==typeof module&&module.exports?module.exports=b(require("isotope-layout/js/layout-mode"),require("packery")):b(a.Isotope.LayoutMode,a.Packery)}(window,function(a,b){var c=a.create("packery"),d=c.prototype,e={_getElementOffset:!0,_getMeasurement:!0};for(var f in b.prototype)e[f]||(d[f]=b.prototype[f]);var g=d._resetLayout;d._resetLayout=function(){this.packer=this.packer||new b.Packer,this.shiftPacker=this.shiftPacker||new b.Packer,g.apply(this,arguments)};var h=d._getItemLayoutPosition;d._getItemLayoutPosition=function(a){return a.rect=a.rect||new b.Rect,h.call(this,a)};var i=d.needsResizeLayout;d.needsResizeLayout=function(){return this._getOption("horizontal")?this.needsVerticalResizeLayout():i.call(this)};var j=d._getOption;return d._getOption=function(a){return"horizontal"==a?void 0!==this.options.isHorizontal?this.options.isHorizontal:this.options.horizontal:j.apply(this.isotope,arguments)},c});


// Venedor Theme Helper functions
var vndHlp = {
  // Initialize sections
  initSct( id, query, constructor ) {
    if ( id ) {
      const $c = document.getElementById(id);
      $c.childElementCount > 0 && constructor($c);
    } else {
      document.querySelectorAll(query).forEach(function($c) {
        $c.childElementCount > 0 && constructor($c);
      });
    }
  },

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  },

  parseVideo (url) {
    url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

    if (RegExp.$3.indexOf('youtu') > -1 ) {
      var type = 'youtube';
    } else if (RegExp.$3.indexOf('vimeo') > -1 ) {
      var type = 'vimeo';
    }

    return {
      type: type,
      id: RegExp.$6
    }
  },

  // Initialize Video play/pause controls
  ctrVideo () {
    $('video').each(function(i, video) {
      video.onplay = function(e, i){
       this.parentElement.classList.add('playing');
       this.parentElement.classList.remove('paused');
      }

      video.onpause = function(e, i){
        this.parentElement.classList.remove('playing');
        this.parentElement.classList.add('paused');
      }
    });

    $('.play-video').on('click', function(e) {
      e.preventDefault();
      const $vd = this.parentElement.querySelector('video');
      $vd.muted = false;
      $vd.play();
      this.parentElement.classList.add('playing');
      this.parentElement.classList.remove('paused');
    });

    $('.pause-video').on('click', function(e) {
      e.preventDefault();
      const $vd = this.parentElement.querySelector('video');
      $vd.pause();
      this.parentElement.classList.remove('playing');
      this.parentElement.classList.add('paused');
    });
  },

  parseMoney (money, origin) {
    if ( money ) {
      if ( vndCurrency.currency_format.indexOf('comma_separator') < 0 ) {
        money = money.replace(/,/g, '');
      } else {
        money = money.replace('.', '').replace(/,/g, '.');
      }

      return money.match(/([0-9]*[.])?[0-9]+/g)[0];
    }
  },

  initCookieNotify() {
    var $cookie_div = $('.cookie-notify-container');
    if ( $cookie_div.length > 0 && vndHlp.readCookie('vs_cookieAgree') == 'true' ) {
      $cookie_div.remove();
    } else {
      $cookie_div.addClass('active');
    }

    $('.btn-cookie-close').on('click', function(e) {
      e.preventDefault();
      $cookie_div.remove();
      vndHlp.createCookie('vs_cookieAgree', 'true', 1);
    });
  },

  createCookie (name, value, days ) {
    var expires;
    if (days ) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }
    else {
      expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  },

  readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for ( var i = 0; i < ca.length; i++ ) {
      var c = ca[i];
      while ( c.charAt(0) === ' ' ) c = c.substring(1, c.length);
      if ( c.indexOf(nameEQ) === 0 ) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },

  eraseCookie(name) {
    vndHlp.createCookie(name, "", -1);
  },

  refreshCart(cart) {
    var mpInstance = $.magnificPopup.instance;
    if ( mpInstance.isOpen ) {
      mpInstance.close();
    }

    $('.cart-total').text(cart.item_count);
    $('.icon-cart__total').text(cart.item_count);
    $('.icon-cart__count .money').text(vndHlp.formatMoney(cart.total_price));

    // Get current cart freeshpping amount
    let percentage = 0;
    const $freeshipProgress = document.querySelector('.vnd-crt__fsa-bar');
    if ($freeshipProgress) {
      percentage = $freeshipProgress.style.width;
    }

    // Update cart list
    $.get("/cart?view=ajax", function(list) {
      $(".cart-dropdown").html(list);

      cartPage.initCartPp();

      document.dispatchEvent(
        new CustomEvent('vnd_ajx:crt:success', {
          bubbles: true,
          cancelable: true,
          detail: percentage
        })
      );
    });
  },

  // Check if device size is mobile
  isMobile() {
    return document.body.clientWidth + vndTheme.scroll_width < 992;
  },

  isPhone() {
    return document.body.clientWidth + vndTheme.scroll_width < 768;
  },

  // Check if device type is touch
  isTchDvc() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },

  // Check if mobile menu initialized
  didMblInit() {
    return $('body').hasClass('mobile-menu-init');
  },

  // Check if mobile sidebar initialized
  didMblSdbInit() {
    return $('body').hasClass('mobile-sidebar-init');
  },

  // Enter full screen with given class name element
  entFScr(class_name) {
    $(class_name).attr('id', 'fullscreen-element');
    var el = document.getElementById('fullscreen-element');
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.mozRequestFullScreen) { /* Firefox */
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) { /* IE/Edge */
      el.msRequestFullscreen();
    }
  },

  // Exit fullscreen
  extFScr() {
    if ( document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    }
  },

  // Initialize wishlist
  wslst() {
    productsCookieList();
  },

  // Initialize comparelist
  cplst() {
    const setting = {
      type: "vnd_cplst",
      pageClass: '.page-compare',
      btnClass:   ".btn-compare",
      listItem:   '.compare-card',
      listCount:  '.compare-count',
      listGrid:   '.compare-grid',
      removeAll:  '.clear-cplst',
      ajaxTarget: '?view=compare_item_html'
    }

    productsCookieList(setting);
    var list = localStorage.getItem("vnd_cplst");
    if ( list != null ) {
      $('.compare-grid').show();
    }
  },

  updateCpWsCt(target) {
    let $listCount = target.querySelector('.wishlist-count');
    let list = localStorage.getItem('vndWslst') || [];
    if (list.length > 0) {
      list = JSON.parse(list);
    }
    $listCount && ($listCount.innerText = list.length);

    $listCount = target.querySelector('.compare-count');
    list = localStorage.getItem('vnd_cplst') || [];
    if (list.length > 0) {
      list = JSON.parse(list);
    }
    $listCount && ($listCount.innerText = list.length);
  },

  showLoading() {
    $('.vnd-loading-scr').fadeIn('fast');
  },

  hideLoading() {
    $('.vnd-loading-scr').fadeOut('fast');
  },

  formatMoney(cents) {
    const moneyFormat = vndCurrency.currency_format == 'money_with_currency_format'
      ? vndCurrency.money_with_currency
      : vndCurrency.money_format;
    const decimal = vndCurrency.price_format == 'without_zero' ? 0 : 2;
    const price = (cents / 100).toFixed(decimal)
    return moneyFormat.replace(`\{\{amount\}\}`, price);
  }
}

////////////////////////////////////////////////////////////
///////////////       Define Elements        ///////////////
////////////////////////////////////////////////////////////
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('[name="locale_code"], [name="country_code"]'),
      buttons: this.querySelectorAll('.dropdown-item')
    };

    this.elements.buttons.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
if (!window.customElements.get('localization-form')) {
  customElements.define('localization-form', LocalizationForm);
}

class ProductDeal extends HTMLElement {
  constructor() {
    super();

    this.DIRECTIVE_KEY_MAP = {
      H: "hours",
      M: "minutes",
      S: "seconds",
      D: "totalDays"
    };

    this.matchers = [];
    this.defaultOptions = {
      precision: 100,
      elapse: false,
      defer: false
    };

    this.matchers.push(/^[0-9]*$/.source);
    this.matchers.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    this.matchers.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source);
    this.matchers = new RegExp(this.matchers.join("|"));

    this.el = this.querySelector('.product-date');

    this.initCountDown();
  }

  parseDateString(dateString) {
    if (dateString instanceof Date) {
        return dateString;
    }
    if (String(dateString).match(this.matchers)) {
        if (String(dateString).match(/^[0-9]*$/)) {
            dateString = Number(dateString);
        }
        if (String(dateString).match(/\-/)) {
            dateString = String(dateString).replace(/\-/g, "/");
        }
        return new Date(dateString);
    } else {
        throw new Error("Couldn't cast `" + dateString + "` to a date object.");
    }
  }

  escapedRegExp(str) {
    var sanitize = str.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    return new RegExp(sanitize);
  }

  strftime(offsetObject) {
    return function(format) {
      var directives = format.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (directives) {
        for (var i = 0, len = directives.length; i < len; ++i) {
          var directive = directives[i].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/), regexp = escapedRegExp(directive[0]), modifier = directive[1] || "", plural = directive[3] || "", value = null;
          directive = directive[2];
          if (DIRECTIVE_KEY_MAP.hasOwnProperty(directive)) {
            value = DIRECTIVE_KEY_MAP[directive];
            value = Number(offsetObject[value]);
          }
          if (value !== null) {
            if (modifier === "!") {
              value = pluralize(plural, value);
            }
            if (modifier === "") {
              if (value < 10) {
                value = "0" + value.toString();
              }
            }
            format = format.replace(regexp, value.toString());
          }
        }
      }
      format = format.replace(/%%/, "%");
      return format;
    };
  }

  pluralize(format, count) {
    var plural = "s", singular = "";
    if (format) {
        format = format.replace(/(:|;|\s)/gi, "").split(/\,/);
        if (format.length === 1) {
          plural = format[0];
        } else {
          singular = format[0];
          plural = format[1];
        }
    }
    if (Math.abs(count) > 1) {
        return plural;
    } else {
        return singular;
    }
  }

  countdown(finalDate, options) {
    this.interval = null;
    this.offset = {};
    this.options = Object.assign({}, this.defaultOptions);
    this.firstTick = true;

    if (options) {
      if (typeof options === "function") {
        this.el.addEventListener("update.countdown", options);
        this.el.addEventListener("stoped.countdown", options);
        this.el.addEventListener("finish.countdown", options);
      } else {
        this.options = Object.assign(this.options, options);
      }
    }

    this.setFinalDate(finalDate);
    if (this.options.defer === false) {
      this.start();
    }
  }

  start() {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
    var self = this;
    this.update();
    this.interval = setInterval(function() {
      self.update.call(self);
    }, this.options.precision);
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
    this.dispatchEvent("stoped");
  }

  pause() {
    this.stop();
  }

  remove() {
    this.stop.call(this);
  }

  setFinalDate(value) {
    this.finalDate = this.parseDateString(value);
  }

  update() {
    if (!this.el.closest("html")) {
      this.remove();
      return;
    }
    var now = new Date(), newTotalSecsLeft;
    newTotalSecsLeft = this.finalDate.getTime() - now.getTime();
    newTotalSecsLeft = Math.ceil(newTotalSecsLeft / 1e3);
    newTotalSecsLeft = !this.options.elapse && newTotalSecsLeft < 0 ? 0 : Math.abs(newTotalSecsLeft);
    if (this.totalSecsLeft === newTotalSecsLeft || this.firstTick) {
      this.firstTick = false;
      return;
    } else {
      this.totalSecsLeft = newTotalSecsLeft;
    }
    this.elapsed = now >= this.finalDate;
    this.offset = {
      seconds: this.totalSecsLeft % 60,
      minutes: Math.floor(this.totalSecsLeft / 60) % 60,
      hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
      totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
    };
    if (!this.options.elapse && this.totalSecsLeft === 0) {
      this.stop();
      this.dispatchEvent("finish");
    } else {
      this.dispatchEvent("update");
    }
  }

  dispatchEvent(eventName) {
    this.el.dispatchEvent(new CustomEvent(eventName + '.countdown', {
      bubbles: true,
      cancelable: true,
      detail: {
        finalDate: this.finalDate,
        elapsed: this.elapsed,
        offset: Object.assign({}, this.offset),
        strftime: this.strftime(this.offset)
      }
    }));
  }

  initCountDown() {
    const _this = this;
    const date = this.el.dataset.datetime;
    let html;

    if (new Date(date) > new Date(Date.now())) {
      this.countdown(new Date(date), function(e) {
        html = '';
        html += '<div class="dealtime-container"><div class="dealtime-wrapper"><span class="countdown-number">' + e.detail.offset.totalDays + '</span><span class="countdown-text">' + vndTheme.t_d + '</span></div>';
        html += '<div class="dealtime-wrapper"><span class="countdown-number">' + e.detail.offset.hours + '</span><span class="countdown-text">' + vndTheme.t_h + '</span></div>';
        html += '<div class="dealtime-wrapper"><span class="countdown-number">' + e.detail.offset.minutes + '</span><span class="countdown-text">' + vndTheme.t_m + '</span></div>';
        html += '<div class="dealtime-wrapper"><span class="countdown-number">' + e.detail.offset.seconds + '</span><span class="countdown-text">' + vndTheme.t_s + '</span></div></div>';

        html = new DOMParser().parseFromString(html, 'text/html').querySelector('.dealtime-container')
        _this.el.innerHTML = html.innerHTML;
      });
    } else {
      if (this.closest('.has-deal')) {
        this.closest('.has-deal').classList.remove('has-deal');
      }
      this.parentElement.removeChild(this);
    }
  }
}
if (!window.customElements.get('product-deal')) {
  customElements.define('product-deal', ProductDeal);
}

// Sidebar Element
class VndSideBar extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.sidebar-carousel .items-carousel').forEach($carousel => {
      initSlider($carousel);
    });

    this.initSticky();

    this.querySelectorAll('.expand').forEach($expander => {
      $expander.addEventListener('click', function(e) {
        e.preventDefault();
        const $parent = $expander.parentElement;

        if ($parent.classList.contains('expanded')) {
          $parent.classList.remove('expanded');
          $parent.querySelector('.nav-child__wrapper').classList.add('collapsed');
        } else {
          $parent.classList.add('expanded');
          $parent.querySelector('.nav-child__wrapper').classList.remove('collapsed');
        }
      });
    });
  }

  initSticky() {
    if (vndHlp.isMobile()) {
      return;
    }

    const $grid = this.parentElement.querySelector('.large-9');
    const $target = $grid.offsetHeight > this.offsetHeight ? this : $grid;

    if ($target.classList.contains('sticky-dir-up') || $target.classList.contains('sticky-dir-down')) {
    } else {
      $target.classList.add('sticky-dir-up');
    }

    $target.lastKnownY = window.scrollY;
    if (vndTheme.stk_el && !vndTheme.stk_el.currentTop) {
      vndTheme.stk_el.currentTop = 0;
    } else {
      return;
    }

    vndTheme.stk_el.initialTopOffset = parseInt(window.getComputedStyle($target).top);

    window.onscroll = function() {
      var bounds = $target.getBoundingClientRect(),
          maxTop = bounds.top + window.scrollY - $target.offsetTop + vndTheme.stk_el.initialTopOffset,
          minTop = $target.clientHeight - window.innerHeight + 30;

      if (window.scrollY < $target.lastKnownY) {
        vndTheme.stk_el.currentTop -= window.scrollY - $target.lastKnownY;
      } else {
        vndTheme.stk_el.currentTop += $target.lastKnownY - window.scrollY;
      }

      vndTheme.stk_el.currentTop = Math.min(Math.max(vndTheme.stk_el.currentTop, -minTop), maxTop, vndTheme.stk_el.initialTopOffset);
      $target.lastKnownY = window.scrollY;

      $target.style.top = vndTheme.stk_el.currentTop + 'px';
    }
  }
}
if (!window.customElements.get('side-bar')) {
  customElements.define('side-bar', VndSideBar);
}

// Cart Terms and Conditions Agreement
class CartTac extends HTMLElement {
  constructor() {
    super();

    const $input = this.querySelector('input');
    const vs_tac_agreement = vndHlp.readCookie('vs_tac_agreement');

    if (vs_tac_agreement == 'true') {
      $input.checked = true
    }
  }
}
if (!window.customElements.get('cart-tac')) {
  customElements.define('cart-tac', CartTac);
}


// Flickity component
class ThemeCarousel extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.js-carousel');

    const auto_speed = parseInt(this.dataset.auto);
    const autoPlay   = auto_speed > 0 ? auto_speed * 1000 : false;
    const showNav      = this.dataset.nav == 'true';
    const showDots     = this.dataset.dots == 'true';
    const pauseOnHover = this.dataset.pausehover == 'true';
    const cellAlign    = this.dataset.cellalign || 'left';
    const wrapAround   = this.dataset.wraparound == 'true';
    const groupCells   = this.dataset.groupcells != 'false';

    this.config = {
      autoPlay: autoPlay,
      draggable: true,
      wrapAround: wrapAround,
      prevNextButtons: showNav,
      pageDots: showDots,
      imagesLoaded: true,
      cellAlign: cellAlign,
      groupCells: groupCells,
      lazyLoad: 2,
      pauseOnHover: pauseOnHover,
      contain: true
    }

    this.setupCarousel();
  }

  setupCarousel() {
    this.flickity = new Flickity(this.container, this.config);
  }
}
if (!window.customElements.get('theme-carousel')) {
  customElements.define('theme-carousel', ThemeCarousel);
}


////////////////////////////////////////////////////////////
///////////////       Define Sections        ///////////////
////////////////////////////////////////////////////////////

// Topbar and Header
var vndTopbar = {
  onLoad(container) {
    if ( container.classList.contains('initialized') ) {
      return;
    }

    container.classList.add('initialized');

    vndHeader.initCartTouch(container);
    setTimeout(() => {
      vndHeader.initLanguageSwitcher(container);
    }, 350);

    const popups = new vndTheme.Popups(container),
          dropdowns = new vndTheme.Dropdowns(container);
  },

  onSelect(evt) {
    vndHlp.updateCpWsCt(evt.target);
  }
}

var vndHeader = {
  stkHd: null, // Sticky Header
  container: null,

  initStickyHeader: function() {
    if ((typeof Waypoint == 'undefined') || (typeof Waypoint.Sticky == 'undefined')) {
      return;
    }

    const $header = document.querySelector("#shopify-section-header .header");
    const $mobile_header = document.querySelector('.header-mobile.sticky-mobile-enable');

    if (vndHlp.isPhone() && $mobile_header) {
      this.stkHd = new Waypoint.Sticky({
        element: $mobile_header,
        stuckClass: "sticky-active",
        offset: -380
      });
    } else if ( ($header.classList.contains('sticky-enable') && !vndHlp.isMobile()) ||
         ($header.classList.contains('sticky-mobile-enable') && vndHlp.isMobile()) ) {
      this.stkHd = new Waypoint.Sticky({
        element: $header,
        stuckClass: "sticky-active",
        offset: -160
      });
    }
  },

  // Adjust if child menu overflows window
  initMenuPosition: function(onresize) {
    if(vndHeader.container.id != "shopify-section-header") {
      return;
    }
    const nodelist = document.getElementById("shopify-section-header").querySelectorAll('.vnd-desk-menu .dropdown-classic, .vnd-desk-menu .dropdown-classic .menu-grandchild');
    const megalist = document.getElementById("shopify-section-header").querySelectorAll('.vnd-desk-menu .sub-menu.boxed');

    const limit = window.innerWidth;
    for ( let i = 0; i < nodelist.length; i++ ) {
      const menu = nodelist.item(i),
            ln = menu.getBoundingClientRect().right + 50;

      if ( ln > limit ) {
        menu.closest('.header-menu-item').classList.add('relative');
        menu.classList.add('pos-right');
      }
    }

    for ( let i = 0; i < megalist.length; i++ ) {
      const menu = megalist.item(i),
            ln = menu.getBoundingClientRect().right + 50;

      if ( ln > limit ) {
        menu.style.right = (ln - limit) / 2 + 'px';
      }
    }
  },

  initLanguageSwitcher: function(container) {
    const $lang = $(container).find(".language-wrapper"),
          $mb_sch_btn = container.querySelector('.header-search__mobile-button'),
          $sch_btn = container.querySelector('button.search-button'),
          $sch_form = container.querySelector('.search-form'),
          $sch_ctn = container.querySelector('.search-input-container');

    if ($sch_ctn && window.getComputedStyle($sch_ctn).position == 'absolute') {
      var bounds = $sch_ctn.getBoundingClientRect();
      if (bounds.left < 0) {
        $sch_ctn.style.left = '0';
        $sch_ctn.style.right = 'auto';
      } else if (bounds.right > document.body.offsetWidth) {
        $sch_ctn.style.left = 'auto';
        $sch_ctn.style.right = '0';
      }
    }

    if ($mb_sch_btn) {
      $mb_sch_btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        $sch_form.classList.add('js-hover');
      }
    }

    if ( $sch_btn && vndHlp.isTchDvc() ) {
      $sch_btn.ontouchstart = function(e) {
        if ( !$sch_form.classList.contains('js-hover') ) {
          if ( e.cancelable ) {
            e.preventDefault();
            e.stopPropagation();
          }
          $sch_form.classList.add('js-hover');
        }
      };
    }
  },

  initCartTouch: function(container) {
    const $cart_dropdown = document.body.querySelector('.cart-dropdown'),
          $cart_icon = container.querySelector('.icon-cart');

    if (!$cart_dropdown || !$cart_icon) {
      return;
    }

    if (!$cart_dropdown.classList.contains('moved') && vndTheme.stt.ajx_crt_eft == 'sidebar') {
      document.body.appendChild($cart_dropdown);
      $cart_dropdown.classList.add('moved');
    }

    document.body.querySelectorAll('.cart-dropdown').forEach(($cd, index) => {
      if (!$cd.classList.contains('moved') && $cd.classList.contains('sidebar')) {
        $cd.remove();
      }
    });

    if (vndTheme.stt.ajx_crt_eft == 'sidebar') {
      $cart_icon.onclick = function(e) {
        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent('vnd_ajx:crt:success', {
            bubbles: true,
            cancelable: true
          })
        );
      }
    } else {

      if (vndHlp.isMobile()) {
        $cart_icon.parentElement.appendChild($cart_dropdown);
      }

      if ( !vndHlp.isTchDvc() ) {
        return;
      }

      $cart_icon.ontouchstart = function(e) {
        if ( e.cancelable ) {
          e.preventDefault();
        }
        $($cart_dropdown).toggleClass('active');
      };

      $(window).on('click touchstart', function(e) {
        if ( $('.cart-dropdown.active').length
          && !$(e.target).hasClass('cart-wrapper')
          && !$(e.target).parents('.cart-wrapper').length ) {
            $('.cart-dropdown.active').removeClass('active');
          }
      });
    }
  },

  onLoad: function(container) {
    if ( container.classList.contains('initialized') ) {
      return;
    }

    vndHeader.container = container;
    container.classList.add('initialized');

    vndHeader.initCartTouch(container);
    vndHeader.initStickyHeader();
    vndHeader.initMenuPosition(false);

    const popups = new vndTheme.Popups(container),
          dropdowns = new vndTheme.Dropdowns(container);

    setTimeout(() => {
      vndHeader.initLanguageSwitcher(container);
    }, 350);
  },

  onUnload: function(evt) {
    this.stkHd && this.stkHd.destroy();
  },

  onSelect(evt) {
    vndHlp.updateCpWsCt(evt.target);
    const popups = new vndTheme.Popups(evt.target),
          dropdowns = new vndTheme.Dropdowns(evt.target);
  },

  onBlkSelect(evt) {
    $(evt.target).parents('.header-menu-item').addClass('js-hover');
  },

  onBlkDeselect(evt) {
    $(evt.target).parents('.header-menu-item').removeClass('js-hover');
  }
}

// Mobile Header
var vndMbHd = {
  onLoad(container) {
    vndHeader.initCartTouch(container);
    vndHeader.initLanguageSwitcher(container);
    const popups = new vndTheme.Popups(container),
          dropdowns = new vndTheme.Dropdowns(container);
  }
}

// slideshow with flickity
var slideShow = {
  onLoad($container) {
    var $sliders = $container.getElementsByClassName('flickity-carousel');
    if ( $sliders.length == 0 ) {
      return;
    }

    initIframes($container);

    for (let i = 0; i < $sliders.length; i++) {
      const $slider = $sliders[i];

      const hasMultipleCells = $slider.querySelectorAll('.slide-item').length > 1;
      const auto_play = $slider.dataset.auto > 0 ? $slider.dataset.auto*1000 : false;
      const wrap_around = $slider.dataset.wraparound == 'true';
      const pause_on_hover = $slider.dataset.pausehover == 'true';
      let show_nav = $slider.dataset.nav == 'true';
      let show_dots = $slider.dataset.dots == 'true';

      if ( !hasMultipleCells ) {
        show_nav = false;
        show_dots = false;
      }

      // check expansion option
      if ($slider.classList.contains('with-categories-menu')) {

        if (!vndHlp.isPhone()) {
          const $parent = $slider.parentElement,
                $acc_wr = $slider.nextElementSibling,
                scroll_width = vndTheme.scroll_width;

          let sw,
              prev_width;

          if ($parent.previousElementSibling) {
            prev_width = $parent.previousElementSibling.offsetWidth;
            sw = $parent.parentElement.offsetWidth - prev_width;
          } else {
            sw = $parent.parentElement.offsetWidth;
            prev_width = 0;
          }

          $acc_wr.style.width = sw + 'px';
          if ($parent.classList.contains('expand-te')) {
            $parent.style.width = (window.innerWidth - $parent.parentElement.offsetWidth - scroll_width ) / 2 + sw + 'px';
            $parent.style.minWidth = $parent.style.width;
            const $slides = $slider.getElementsByClassName('slide-item');
            Array.from($slides).forEach(($sl) => {
              $sl.style.width = sw + 'px';
            });
          } else {
            $parent.style.width = sw + 'px';
          }
        }
      }

      if ( !$slider.classList.contains('flickity-enabled') ) {

        $($slider).flickity({
          adaptiveHeight: true,
          wrapAround: wrap_around,
          autoPlay: auto_play,
          pauseAutoPlayOnHover: pause_on_hover,
          prevNextButtons: show_nav,
          cellAlign: 'left',
          pageDots: show_dots,
          imagesLoaded: true,
          lazyLoad: 2,
          on: {
            select: function (index) {
              const flkty = this;
              const v_e = flkty.selectedElement.querySelector('video');
              if (v_e) {
                const playWholeVideo = flkty.selectedElement.querySelector('.video-wrap').dataset.wholeplay;
                if ( playWholeVideo == 'true' && flkty.slides.length > 1 ) {
                  flkty.stopPlayer();
                  v_e.loop = false;
                  v_e.onended = function (e, i) {
                    flkty.next();
                  }
                }
              };
            },
            change: function (index) {
              const flkty = this;
              if ( flkty.slides.length > 1 ) {
                const previousIndex = index === 0 ? flkty.slides.length - 1 : index - 1,
                      previousElement = flkty.slides[previousIndex].getCellElements(),
                      nextElement = flkty.selectedElement,
                      v_e = nextElement.querySelector('video');

                if (v_e) {
                  const playWholeVideo = nextElement.querySelector('.video-wrap').dataset.wholeplay,
                        prev_video = previousElement[0].querySelector('video');
                  if (prev_video) {
                    prev_video.pause();
                  }

                  if ( playWholeVideo == 'true' ) {
                    flkty.stopPlayer();
                    v_e.loop = false;
                    v_e.onended = function () {
                      flkty.next();
                    }
                  }
                  v_e.muted = false;
                  v_e.play();
                };
              }
            },
            ready: function() {
              if ( this.element.classList.contains('with-categories-menu') ) {
                const $nc = this.element.nextElementSibling;
                if (this.prevButton) {
                  $nc.appendChild(this.prevButton.element);
                  $nc.appendChild(this.nextButton.element);
                }
                if (this.pageDots) {
                  $nc.appendChild(this.pageDots.holder);
                }
              }
            }
          }
        });
      }
    };
  },

  onResize(container) {
    const sliders = $(container).find('.flickity-carousel');
    sliders.each( function() {
      const slider = $(this);
      slider.flickity('resize');
    });
  }
}

// Parallax Lookbook Section (with slideshow)
var parallaxLookbook = {
  calcLookbookSpots: (left, viewWidth, viewHeight, viewRatio, imgRatio) => {
    var viewRatio = viewHeight / viewWidth;
    var backImgWidth = viewWidth;

    if ( viewRatio > imgRatio ) {
      backImgWidth = viewHeight / imgRatio;
    }
    return `${ 50 + (left - 50) * backImgWidth / viewWidth }%`
  },

  calcTransformValue(pageTop, windowHeight, sectionTop, sectionHeight) {
    return 0 - sectionHeight * 0.3 / windowHeight * (sectionTop - pageTop);
  },

  isInView(container) {
    const bounding = container.getBoundingClientRect(),
          out = {};

    out.top = bounding.top < 0;
    out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
    out.any = out.top || out.bottom;
    out.all = out.top && out.bottom;
    const inview =
      ( bounding.top >= 0 && bounding.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
      ( bounding.bottom >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight));

    return inview || out.all
  },

  calcBgPos(container) {
    let windowHeight = $(window).innerHeight();
    let pageTop = $(window).scrollTop();
    let sectionHeight = container.querySelector('.parallax-container').offsetHeight;
    let sectionTop = $(container).offset().top;

    let transformHeight = parallaxLookbook.calcTransformValue(pageTop, windowHeight, sectionTop, sectionHeight);
    let parallaxHeight = sectionHeight * 1.3;

    $(container).find('.image-container').css({ 'height': parallaxHeight, 'transform': `translate3d(0px,${transformHeight}px, 0px`, "-webkit-backface-visibility": "hidden" });

    $(window).on('scroll', function() {
      pageTop = $(window).scrollTop();

      if (parallaxLookbook.isInView(container)) {
        transformHeight = parallaxLookbook.calcTransformValue(pageTop, windowHeight, sectionTop, sectionHeight);
        parallaxHeight = sectionHeight * 1.3;

        $(container).find('.image-container').css({ 'transform': `translate3d(0px,${transformHeight}px, 0px` });
        $(container).find('.lookbook-spot').css({ 'transform': `translate3d(0px,${transformHeight}px, 0px`, "-webkit-backface-visibility": "hidden" });
      }
    });
  },

  onLoad: (container) => {
    initLookbookSpots(container);
    let imgRatio = 1 / $(container).find('.parallax-container').data('image-ratio');
    let viewWidth = $(container).outerWidth();
    let viewHeight = $(container).outerWidth();

    // Set lookbook spot position to corresponding window size
    $(container).find('.lookbook-spot').css("left", function() {
      return parallaxLookbook.calcLookbookSpots(this.dataset.left, imgRatio, viewWidth, viewHeight);
    });
    parallaxLookbook.calcBgPos(container);

    $(window).resize(function() {
      $(container).find('.lookbook-spot').css("left", function() {
        return parallaxLookbook.calcLookbookSpots(this.dataset.left, imgRatio, viewWidth, viewHeight);
      });

      parallaxLookbook.calcBgPos(container);
    });
  }
}

// Lookbook section
var lookbookSection = {
  onLoad: (container) => {
    initLookbookSpots(container);
  }
}

// Lookbook section
var lookbookSection2 = {
  onLoad: (container) => {
    initLookbookSwitch(container);
  }
}

// Section with sidebars
var groupContent = {
  onLoad(container) {
    container.querySelectorAll('.items-carousel').forEach(function(carousel) {
      initSlider(carousel);
    });
    container.querySelectorAll('.vs-grid-isotope').forEach(function(grid) {
      new vndTheme.Dropdowns(grid);
      initIstSection(grid);
    });

    // Initialize sliders inside group content section
    slideShow.onLoad(container);
    groupContent.initBrandSearch(container);
  },

  initBrandSearch(container) {
    const tagsList = [];
    const $form = container.querySelector('.search-form__with-brand');
    let searchByName = '';

    if ($form) {
      $form.addEventListener('input', event => {
        if (event.target.name != 'q') {
          searchByName = event.target.name;
        }
      });

      $form.addEventListener('submit', event => {
        event.preventDefault();

        const formData = new FormData($form);
        const searchParams = new URLSearchParams(formData);
        searchParams.set('q', `${searchParams.get('q')}*`);
        location = `/search?${searchParams.toString()}`;
      });
    }
  }
}

// Section with sidebars
var vndSectionSlider = {
  onLoad(container) {
    let carouselElems = container.querySelectorAll('.items-carousel')
    carouselElems.forEach(function(carousel) {
      initSlider(carousel);
    });

    if(carouselElems.length > 1) {
      window.dispatchEvent(new Event('resize'));
    }
  }
}

// Packery Section
var vndPkrSt = {
  onLoad(container) {
    slideShow.onLoad(container);

    $(container).find('.packery-container').each(function() {
      var el = this;
      vndPkrSt.initPkr(el);

      $(window).on('resize', function() {
        slideShow.onResize(container);
        vndPkrSt.initPkr(el);
      });
    });
  },

  initPkr(el) {
    $(el).isotope({
      itemSelector: '.packery-item',
      layoutMode : 'packery'
    });
  }
}

var vndMsrGrd = {
  onLoad(container) {
    const $ic = container.querySelector('.masonry-grid-wrapper');
    if ( !$ic ) return;
    const iso = new Isotope($ic, {
      itemSelector: '.image-block-item',
      masonry: {
        columnWidth: '.grid-sizer'
      }
    })
  }
}

// Tabs page
var vndPageTabs = {
  onLoad(container) {
    initTabs(container);
  }
}

// Image with text 2
var vndSectionImage2 = {
  onLoad(container) {
    const selectors = {
      parent: '.content-slideshow',
      slider: '.flickity-carousel',
    };

    const $parent = container.querySelector(selectors.parent);
    const $slider = container.querySelector(selectors.slider);

    if (!vndHlp.isMobile()) {
      const parent_width = $parent.offsetWidth;
      const prev_width = $parent.previousElementSibling.offsetWidth; // Plus 30 means padding of the parent element
      const scroll_width = vndTheme.scroll_width;

      $parent.style.width = parent_width - prev_width + (window.innerWidth - parent_width - scroll_width) / 2 + 'px';
      $parent.style.minWidth = $parent.style.width;
    }

    initSlider($slider);
  }
};

// Products masonry carousel
var vndServicePromotion = {
  onLoad(container) {
    const selectors = {
      block: '.c-e__fsa',
    };

    container.querySelectorAll(selectors.block).forEach( function($t) {
      new Waypoint({
        element: $t,
        offset: '84%',
        handler: function() {
          this.element.classList.add('c-e__fsa-a');
        }
      });
    });
  }
}

// Collections Tab section
var vndIstSection = {
  onLoad(container) {
    initIstSection(container);
    new vndTheme.Dropdowns(container);
  }
}

///////////////////////////////////
//        Theme Functions        //
///////////////////////////////////

function initMobileMenu() {
  $('.header-menu-item a').on('click', function(e) {
    if ( $(e.currentTarget).attr('href') == '#') {
      e.preventDefault();
    }
  });

  document.querySelectorAll('.vnd-link__move').forEach($link => {
    $link.addEventListener('click', function(event) {
      const $target = document.querySelector(event.currentTarget.hash);
      if (!$target) {
        return;
      }

      event.preventDefault();

      document.querySelectorAll('.vnd-link__move').forEach($vndlnk => {
        $vndlnk.parentElement.classList.remove('active');
      });
      this.parentElement.classList.add('active');

      const $tab_parent = $target.closest('.tabs-content__item');
      if ($tab_parent && !$tab_parent.classList.contains('active')) {
        $tab_parent.parentNode.childNodes.forEach($sibling => {
          $sibling.classList.remove('active');
        });
        $tab_parent.classList.add('active');
      }

      window.scrollTo({
        top: $target.offsetTop - 100,
        behavior: 'smooth'
      });

      if ($target.nodeName == 'INPUT' || $target.nodeName == 'TEXTAREA') {
        setTimeout(() => {
          $target.focus();
        }, 350);
      }
    });
  });


  document.getElementById('mobile-menu-overlay').onclick = function(e) {
    if ( e.cancelable ) {
      e.preventDefault();
    }
    document.body.classList.remove('mobile-menu-open', 'mobile-sidebar-open');
    document.dispatchEvent(
      new CustomEvent('vnd_ajx:crt:close', {
        bubbles: true,
        cancelable: true
      })
    );
  };

  if (!vndHlp.didMblInit()) {
    if ( vndHlp.isMobile() ) {
      document.body.classList.add('mobile-menu-init');

      $('.mobile-btn').on('click', function(e) {
        if ( e.cancelable ) {
          e.preventDefault();
        }

        if (this.classList.contains('activator__drop-down')) {
          $('.mobile-menu__drop-down').toggleClass('active');
        } else {
          document.body.classList.add('mobile-menu-open');
        }
      });

      if ( vndHlp.isTchDvc ) {
        $('.header-menu-item .right-expander').on('click', function(e) {
          e.preventDefault();
          const $pp = this.parentElement.parentElement;
          const $dd = this.parentElement.nextElementSibling;
          if ($pp.classList.contains("expanded")) {
            $pp.classList.remove("expanded");
            $($dd).slideUp();
          } else {
            $($dd).slideDown();
            $pp.classList.add("expanded");
          }
        });
      }

      document.querySelectorAll('.vnd-mobile-menu').forEach(function(menu) {
        initTabs(menu);
      });
    } else {
      $('.dropdown-mega2 .menu-list-header').on('click', function(e) {
        e.preventDefault();
        this.nextElementSibling && this.nextElementSibling.classList.add('active');
        this.closest('.sub-menu').classList.add('sb-expanded');
      });

      $('.dropdown-mega2 .menu-back').on('click', function(e) {
        e.preventDefault();
        $(this.parentElement).find('.menu-grandchild').removeClass('active');
        this.closest('.sub-menu').classList.remove('sb-expanded');
      });

      $('.child-menu-activators .menu-list-header').on('click', function(e) {
        e.preventDefault();
        $(this.closest('.align-start')).find('.child-menu.active').removeClass('active');
        $(this.dataset.target).addClass('active');
      });
    }
  }
}

function initMobileSidebarMenu() {
  if ( vndHlp.isMobile() && !vndHlp.didMblSdbInit() ) {
    $('body').addClass('mobile-sidebar-init');
    const $btn = document.body.querySelector('.mobile-sidebar-toggler');

    if (!$btn) return;

    $btn.onclick = function(e) {
      if ( e.cancelable ) {
        e.preventDefault();
      }
      $('body').toggleClass('mobile-sidebar-open');
    };
  }
}

function initSlider(container) {
  if ( !container ) {
    return;
  }

  const auto_speed = parseInt(container.dataset.auto);

  let autoPlay     = auto_speed > 0 ? auto_speed * 1000 : false,
      showNav      = container.dataset.nav == 'true',
      showDots     = container.dataset.dots == 'true',
      pauseOnHover = container.dataset.pausehover == 'true',
      cellAlign    = container.dataset.cellalign || 'left',
      wrapAround   = container.dataset.wraparound == 'true',
      groupCells   = container.dataset.groupcells || '100%';

  if ( container.dataset.groupcells == 'false' ) {
    groupCells = false;
  }

  showNav = container.childElementCount > 1 && showNav;
  showDots = container.childElementCount > 1 && showDots;

  if ( !container.classList.contains('flickity-enabled') ) {
    return new Flickity(container, {
      wrapAround: wrapAround,
      autoPlay: autoPlay,
      pauseAutoPlayOnHover: pauseOnHover,
      prevNextButtons: showNav,
      pageDots: showDots,
      cellAlign: cellAlign,
      imagesLoaded: false,
      groupCells: groupCells,
      lazyLoad: 2,
      contain: true
    });
  } else {
    return false;
  }
}

function initProductImageSlider(container) {
  container.querySelectorAll('.items-carousel').forEach($slider => {
    if ($slider.classList.contains('flickity-enabled')) {
      return;
    }

    var hasMultipleCells = $slider.getElementsByClassName('product-img').length > 1;
    var mainCarousel = new Flickity($slider, {
      wrapAround: true,
      autoPlay: false,
      prevNextButtons: hasMultipleCells,
      pageDots: false,
      imagesLoaded: true,
      lazyLoad: 2,
      draggable: false,
      initialIndex: 0,
      adaptiveHeight: true
    });

    var $carouselNav = container.querySelector('.thumbs-container');
    if ( $carouselNav ) {
      var $carouselNavCells = $carouselNav.querySelectorAll('.product-thumb');

      for (let index = 0; index < $carouselNavCells.length; index++) {
        const $cell = $carouselNavCells[index];
        $cell.addEventListener('click', function(event) {
          event.preventDefault();
          mainCarousel.select(index);
        });
      }

      mainCarousel.on('change', function(index) {
        $slider.querySelectorAll('.media-container video').forEach($video => {
          $video.pause();
        });

        const $vid = $slider.querySelector('.media-container.is-selected video');
        $vid && $vid.play();
      });
    }
  });
}

function initProductImageGrid(container) {
  var $details = container.querySelector('.product-details-area');
  var $imgs = container.querySelector('.product-img-area');
  var $summary = container.querySelector('.product-details-summary');
  if ( !$details || !$imgs ) {
    return;
  }

  let $target = $details.offsetHeight > $imgs.offsetHeight ? $imgs : $details;
  const m_h = Math.max($details.outerHeight, $imgs.outerHeight);

  if ( window.innerHeight < $target.offsetHeight + 90 ) {
    const waypoint = new Waypoint.Inview({
      element: $target,
      entered: function(direction) {
        if (direction == 'up') {
          this.element.classList.remove('sticky-dir-up');
          this.element.classList.add('sticky-dir-down' );
        }
      },
      exited: function(direction) {
        if (direction == 'down') {
          this.element.classList.remove('sticky-dir-down' );
          this.element.classList.add('sticky-dir-up');
        }
      },
      offset: {
        top: 90,
        bottom: 40
      }
    });
  } else {
    $target.classList.remove('sticky-dir-down');
    $target.classList.add('sticky-dir-up');
  }
}

function initProductZoomPopup(container) {
  // If product gallery is disabled, return
  if ( !vndTheme.ebl_prd_g ) {
    return;
  }

  const img_arr = container.querySelectorAll('.product-layout .product-img');
  for (let i = 0; i < img_arr.length; i++) {
    const img = img_arr[i];
    img.onclick = function(event) {
      const $ct = event.currentTarget;
      if ( $ct.classList.contains('media-container') ) {
        return;
      }

      var $c = $('.product-layout .product-img-area').clone();
      var $p = $c.find('.product-img');
      if ( !$p ) {
        return;
      }

      vndHlp.showLoading();

      var index = 0;
      var $p_a = [];
      $p.each(function(i, e) {
        // Media inner height
        var wh = $(window).innerHeight() - 10;
        // Media inner width
        var ww = $(window).innerWidth() - 10;

        $(e).removeAttr('style');
        $(e).children('img, model-viewer, video').css('max-height', wh);

        // Set model viewer size square
        if ( $(e).find('model-viewer').length ) {
          $(e).css( { height: wh, width: ww });
        }

        $(e).find('.product-images').removeAttr('srcset').removeAttr('data-srcset');
        $(e).find('.zoomImg').remove();

        if ( e.dataset.media == $ct.dataset.media ) {
          index = i;
        }

        $p_a.push({
          galleryContainer: e.outerHTML
        });
      });

      $.magnificPopup.open({
        type: 'inline',
        items: $p_a,
        inline: {
          markup: '<div class="vnd-pp-content relative flex align-center justify-center"><div class="mfp-close"></div><div class="mfp-expander"></div>'+
                    '<div class="mfp-galleryContainer"></div><div class="full-screen"></div>'+
                  '</div>'
        },
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>'
        },
        removalDelay: 350,
        mainClass: 'mfp-appear-anm mfp-product-gallery',
        fixedContentPos: true,
        fixedBgPos: true,
        callbacks: {
          beforeOpen: () => {
            vndHlp.hideLoading();
          },
          open: function() {
            $('.mfp-expander').click( function() {
                $('body').on('click', vndHlp.entFScr('.mfp-product-gallery.mfp-wrap'));
                $('.mfp-expander').hide();
              }
            );
          },

          beforeClose: function() {
            $('body').off('click', vndHlp.entFScr);
          },

          close: function() {
            /* Close fullscreen */
            vndHlp.extFScr();
            return;
          },

          markupParse: function(template, values, item) {}
        }
      }, index);
    };
  }
}

function initLookbookSpots(container) {
  const $ep_list = container.getElementsByClassName('lookbook-expander');

  function hideOther(e) {
    if ( $('.lookbook-spot.active').length
      && !$(e.target).hasClass('lookbook-spot')
      && !$(e.target).parents('.lookbook-spot.active').length ) {
      const $active_spot = document.querySelector('.lookbook-spot.active');
      $active_spot.classList.remove('active');
      $active_spot.lastElementChild.style.top = '';
    }
  }

  for ( let j = 0; j < $ep_list.length; j++ ) {
    const $expander = $ep_list[j];

    $expander.onclick = function(e) {
      e.preventDefault();
      const $parent = this.parentElement,
            $card = this.nextElementSibling;

      hideOther(e);

      $parent.classList.toggle('active');

      if (!$card) return;

      if ( $parent.offsetLeft > $card.offsetWidth ) {
        $card.style.right = '30px';
      } else {
        $card.style.left = '30px';
      }

      // If card overflows parent's territory, then show at the bottom of it
      // 54 is for flickity-dots height
      if ( $parent.offsetTop + $parent.offsetHeight + $card.offsetHeight > $parent.parentElement.offsetHeight - 54 ) {
        $card.style.top = $parent.parentElement.offsetHeight - 54 - $parent.offsetTop - $card.offsetHeight + 'px';
      } else {
        $card.style.top = '';
      }
    };
  }

  $(window).on('click', function(e) {
    // When user clicks outside of lookbook card, hide it
    hideOther(e);
  });
}

function initSwatch(container) {
  // Get all color swatch links in the container
  const cws = container.getElementsByClassName('color-swatch');
  for (let i = 0; i < cws.length; i++) {
    const $cw = cws[i];
    $cw.onclick = function (e) {
      e.preventDefault();
      // Get current active swatch
      const $ca = this.closest('.swatch-group').querySelector('.color-swatch--active');
      $ca && $ca.classList.remove('color-swatch--active');
      this.classList.add('color-swatch--active');

      var $card = this.closest('.product-card');
      var $productImage = $card.querySelector('.product-first-image');
      if ( this.dataset.image ) {
        if ( $productImage.tagName.toLowerCase() == 'div' ) {
          $productImage.dataset.bg = this.dataset.image;
        }
        else {
          $productImage.dataset.src = this.dataset.image;
        }
        $productImage.setAttribute('loading', 'lazy');
      }

      var $variantPrice = $card.querySelector('.current-price');
      if ( this.dataset.price ) {
        $variantPrice.innerHTML = this.dataset.price;
      }
    }
  }
}

// Collection Tab Section
function initIstSection(container) {
  const $scs = container.getElementsByClassName('isotope-container');
  for (let i = 0; i < $scs.length; i++) {
    const $sc = $scs[i],
          $tablist = container.querySelector('.tab-list'),
          init_data = $tablist.querySelector('.isotope-selector.active').dataset.target,
          $tab_btns = container.getElementsByClassName('isotope-selector'),
          $mb_tab_list = container.querySelector('.isotope-mobile-selector'),
          $mb_ab = $mb_tab_list.querySelector('.isotope-mobile-selector .dd-pp__atv');

    const iso = new Isotope($sc, {
      filter: init_data,
      layoutMode: 'fitRows'
    });

    const $hd_list = $sc.getElementsByClassName('ds-none');
    Array.from($hd_list).forEach(($hd) => {
      $hd.classList.remove('ds-none');
    });

    Array.from($tab_btns).forEach(($btn) => {
      $btn.onclick = function (e) {
        e.preventDefault();
        if (vndHlp.isPhone()) {
          $mb_tab_list.querySelector('.isotope-selector.active').classList.remove('active');
        } else {
          $tablist.querySelector('.isotope-selector.active').classList.remove('active');
        }

        $mb_ab.innerHTML = this.innerHTML + $mb_ab.querySelector('.icon-dir-down').outerHTML;
        this.classList.add('active');
        const data = this.dataset.target;
        iso.arrange({ filter: data });
      };
    });
  }
}

function initSizeChart() {
  $('.link-page-popup').on('click', function(e) {
    e.preventDefault();
    let url = this.href,
      delay = 0;
    const mpInstance = $.magnificPopup.instance;

    if ( mpInstance.isOpen ) {
      mpInstance.close();
      delay = 360;
    }

    setTimeout(function() {
      $.ajax({
        url: url,
        dataType: "html",
        type: "GET",
        beforeSend: function() {
          vndHlp.showLoading();
        },
        success: function(data) {
          vndHlp.hideLoading();
          $.magnificPopup.open({
            items: {
              src: data, // can be a HTML string, jQuery object, or CSS selector
              type: 'inline'
            },
            mainClass: 'mfp-appear-anm vnd-sizechart-pp',
            removalDelay: 350,
            fixedContentPos: true,
            fixedBgPos: true,
            callbacks: {
              open: function() {
                const slider = document.querySelector('.vnd-size-chart .items-carousel');
                const size_tab = document.querySelector('.vnd-size-chart');
                initSlider(slider);
                initTabs(size_tab);
              }
            },
          });
        },
        error: function() {
          vndHlp.hideLoading();
          console.log("Quick view error");
        }
      });
    }, delay);
  });
}

function quickViewInit() {
  $('.action-quickview').on("click", function(e) {
    e.preventDefault();
    let url = this.href;
    quickViewLoad(url);
  });
}

function zoomImage(container) {
  if ( !vndHlp.isTchDvc() && vndTheme.ebl_prd_z ) {
    const $zoom_targets = container.getElementsByClassName("product-images");

    for (let i = 0; i < $zoom_targets.length; i++) {
      const $target = $zoom_targets[i];
      $target.parentElement.style.backgroundImage = `url(${$target.dataset.zoom})`;
      $target.parentElement.classList.add('zoom-container')
      $target.parentElement.addEventListener('mousemove', e => {
        zoom(e);
      });
    };
  }
}

function initThumbs(container) {
  const $ctn = document.querySelector(container);
  if ( !$ctn ) {
    return;
  }

  const $wrapper = $ctn.querySelector('.thumbs-wrapper');
  if ( !$wrapper ) {
    return;
  }

  const $viewport = $wrapper.querySelector('.thumbs-viewport');
  const $thumbs_container = $viewport.firstElementChild;
  const $image_area = $wrapper.closest('.product-img-area');

  if (!$image_area.classList.contains('thumbs-bottom') && !vndHlp.isPhone()) { // This means thumbs layout is vertical, not horizontal
    $viewport.style.height = $('.product-images').height() - 2 * parseInt(window.getComputedStyle($wrapper).paddingTop) + 'px';
    $thumbs_container.style.width = $viewport.style.height;
  }

  const hasMultipleCells = $thumbs_container.querySelectorAll('.product-thumb').length > 1;
  new Flickity($thumbs_container, {
    sync: document.querySelector('.product-img-area .items-carousel'),
    contain: true,
    pageDots: false,
    prevNextButtons: hasMultipleCells
  });
}

function quickViewLoad(url) {
  $.ajax({
    url: url,
    dataType: "html",
    type: "GET",
    beforeSend: () => {
      vndHlp.showLoading();
    },
    success: function(data) {
      vndHlp.hideLoading();
      $.magnificPopup.open({
        items: {
          src: '<div class="product-quick-view vnd-pp-content">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        },
        mainClass: 'mfp-appear-anm vnd-qv-pp',
        removalDelay: 350,
        fixedContentPos: true,
        fixedBgPos: true,
        callbacks: {
          open: function() {
            initProductImageSlider(this.content[0]);
            zoomImage(this.content[0]);
            initThumbs(".product-quick-view");
            vndHlp.wslst();
            vndHlp.cplst();
            initSizeChart();
            window.history && window.history.pushState && window.history.pushState({'page': 'quickview'}, 'quickviewed');
          },
          afterClose: function() {
            vndHlp.wslst();
            vndHlp.cplst();
          }
        },
      });
    },
    error: function() {
      vndHlp.hideLoading();
      console.log("Quick view error");
    }
  })
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('.quantity__button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.dataset.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
if (!window.customElements.get('qty-input')) {
  customElements.define('qty-input', QuantityInput);
}

class FeaturedProduct extends HTMLElement {
  constructor() {
    super();
    this.addEvents();
    this._onVariantChange();
  }

  addEvents() {
    this.querySelectorAll('.option-label').forEach($swatch => {
      $swatch.addEventListener('click', () => {
        $swatch.parentElement.querySelector('.active').classList.remove('active');
        $swatch.classList.add('active');
        this._onVariantChange();
      });
    });

    this.querySelectorAll('.option-selector').forEach($select => {
      $select.addEventListener('change', () => {
        this._onVariantChange();
      });
    });
  }

  _onVariantChange() {
    this._getSelectedVariant();
    this._updateUrl();
    this._dispatchEvent();
  }

  _getVariantData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData.variants;
  }

  _getSelectedOptions() {
    const $option1 = this.querySelector('[data-option-index="1"]');
    const $option2 = this.querySelector('[data-option-index="2"]');
    const $option3 = this.querySelector('[data-option-index="3"]');
    let option1 = '';
    let option2 = '';
    let option3 = '';

    if ($option1 && $option1.tagName == 'SELECT') {
      option1 = $option1.value;
      option2 = $option2 ? $option2.value : '';
      option3 = $option3 ? $option3.value : '';
    } else {
      option1 = $option1 && $option1.querySelector('.active')
        ? $option1.querySelector('.active').dataset.value
        : '';
      option2 = $option2 && $option2.querySelector('.active')
        ? $option2.querySelector('.active').dataset.value
        : '';
      option3 = $option3 && $option3.querySelector('.active')
        ? $option3.querySelector('.active').dataset.value
        : '';
    }
    return [option1, option2, option3]
  }

  _getSelectedVariant() {
    const selectedOptions = this._getSelectedOptions();
    this.currentVariant = this._getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return selectedOptions[index] === option
      }).includes(false);
    });
  }

  _updateUrl() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  _dispatchEvent() {
    const $select = this.querySelector('.product-actual-select');
    $select.value = this.currentVariant ? this.currentVariant.id : $select.options[$select.selectedIndex].value;
    const $option = $select.options[$select.selectedIndex];
    selectSwatchCallback(this.currentVariant, $option);
  }
}
if (!customElements.get('featured-product')) {
  customElements.define('featured-product', FeaturedProduct);
}

function selectSwatchCallback(variant, selector) {
  let class_name = '.products-template';
  let $container = document.querySelector('.product-quick-view') || document.querySelector(class_name);

  if (document.querySelector('.template-product__sticky-form')) {
    $container = document.querySelector('.template-product__sticky-form');
  }

  if (!$container) {
    return;
  }

  $container.classList.add('product-disabled');

  if ( variant ) {
    let mf_p = vndHlp.formatMoney(variant.price);
    let mf_c = vndHlp.formatMoney(variant.compare_at_price);

    const $product_price = $container.querySelector('.product-price');
    if ($product_price) {
      const $current_price = $product_price.querySelector('.current-price');
      let $old = $product_price.querySelector('.old-price');

      $current_price.innerHTML = mf_p;
      if ( variant.compare_at_price > 0 ) {
        if (!$old) {
          $old = document.createElement("span");
          $old.classList.add("old-price", "money");
          $product_price.insertBefore($old, $current_price)
        }
        $old.innerHTML = mf_c
        $old.style.display = "inline-block";
      } else if ($old) {
        $old.style.display = "none";
      }
    }

    const $sku = $container.querySelector('.product-sku .sku');
    if ( variant.sku && $sku) {
        $sku.innerHTML = variant.sku;
        $sku.parentElement.style.display = "block";
    } else if ($sku) {
      $sku.parentElement.style.display = "none";
    }

    const $btn = $container.querySelector('.btn-add-cart');
    const $btn_t = $container.querySelector('.btn-add-cart .add-cart__text');
    const $stock = $container.querySelector('.product-details__text .in-stock');

    if ( variant.available ) {
      const stock = parseInt(selector.dataset.quantity);
      const inv_mngmt = selector.dataset.inventoryManagement;

      if (vndTheme.hd_prd_av && !inv_mngmt && $stock) {
        $stock.parentElement.remove();
      } else if ($stock) {
        $stock.innerHTML = stock + ' ' + vndTheme.lang.product.inStock;
      }

      $btn && $btn.classList.add('btn-anm-cart');

      if ($btn_t) {
        const str = ( (inv_mngmt && stock < 1) ? vndTheme.lang.product.preOrder : vndTheme.lang.product.addToCart );
        $btn_t.innerHTML = str;
      }

      $container.classList.remove('product-disabled');
      $btn.disabled = false;
    } else {
      if ($stock) {
        $stock.innerHTML = vndTheme.lang.product.outStock;
      }

      if ($btn_t) {
        $btn_t.innerHTML = vndTheme.lang.product.soldOut;
      }

      $btn && $btn.classList.remove('btn-anm-cart');
      $btn.disabled = true;
    }

    const variant_media = variant.featured_media ? variant.featured_media.id : false;
    const slider = document.querySelector('.product-img-area .items-carousel.flickity-enabled');
    if (slider) {
      const flkty = Flickity.data(slider);
      const $productImages = slider.querySelectorAll('.product-img');
      for (let index = 0; index < $productImages.length; index++) {
        const $image = $productImages[index];
        if ( variant_media && variant_media == $image.dataset.media ) {
          flkty.select(index);
          return false;
        }
      }
    }

    $('.product-layout--grid .product-img-area .product-img').each(function(key, value) {
      var media_id = this.dataset.media;
      if ( variant_media && variant_media == media_id ) {
        $('html, body').animate({
          scrollTop: $(this).offset().top
        }, 450);
        return false;
      }
    });
  }
}

function initTabs(container) {
  container.querySelectorAll('.tabs-nav__item a').forEach( function (tab_atv) {
    tab_atv.addEventListener('click', function (e) {
      e.preventDefault();
      const active_tab_item = container.querySelector('.tabs-nav__item.active')
      if (active_tab_item) {
        active_tab_item.classList.remove('active');
      }
      this.parentElement.classList.add('active');
      container.querySelector('.tabs-content__item.active').classList.remove('active');
      container.querySelector(e.currentTarget.hash).classList.add('active');
      $('.vnd-link__move').parent().removeClass('active');
    });
  });
}

function initNewsletter() {
  if ( vndTheme.ebl_nsl_pp ) {
    $('.subscribe-config input').on('click', function() {
      if ( $(this).parent().find('input:checked').length ) {
        vndHlp.createCookie('vs_newsletterRead', 'true', 1);
      } else {
        vndHlp.eraseCookie('vs_newsletterRead');
      }
    });

    if ( vndHlp.readCookie('vs_newsletterRead') == null ) {
      setTimeout(function() {
        const mpInstance = $.magnificPopup.instance;
        let delay = 0;
        if ( mpInstance.isOpen ) {
          mpInstance.close();
          delay = 360;
        }

        setTimeout(function() {
          $.magnificPopup.open({
            items: {
              src: $('#newsletter-popup'),
              type: 'inline'
            },
            removalDelay: 350,
            mainClass: 'mfp-appear-anm vnd-nsl-pp',
            midClick: true,
            fixedBgPos: true,
            callbacks: {
              beforeClose: function() {
                if (this.content.find('.msg-notice__success').length) {
                  vndHlp.createCookie('vs_newsletterRead', 'true', 1);
                }
              }
            },
          });
        }, delay);
      }, vndTheme.nsl_dl * 1000);
    }
  }
}

vndTheme.UserNotice = (function() {
  let content = "",
      content_type = "";

  let selectors = {
    container: '#user-notice',
    heading: '.heading',
    message: '.message',
    close: '.us-nt__c'
  }

  const $container = document.querySelector(selectors.container),
        $heading = $container.querySelector(selectors.heading),
        $message = $container.querySelector(selectors.message),
        $close = $container.querySelector(selectors.close);

  function _setupNoticeBox(request, type) {
    content = request.responseJSON;
    content_type = type;
    _updateContent();
    _setupEventHandlers();
  }

  function _setupEventHandlers() {
    $close.addEventListener('click', closeNotice);
  }

  function _updateContent() {
    $container.firstElementChild.classList.add('msg-notice__' + content_type);

    $heading.innerHTML = content.message;
    $message.innerHTML = content.description;

    if (!content.message ) {
      $heading.style.display = 'none';
    } else {
      $heading.style.display = 'block';
    }

    $container.classList.add('loaded');
  }

  function closeNotice(e) {
    $container.classList.add('disappearing');
    setTimeout(() => {
      $container.classList.remove('disappearing', 'loaded');
      $container.firstElementChild.classList.remove('msg-notice__info', 'msg-notice__warn', 'msg-notice__error', 'msg-notice__success');
    }, 480);
  }

  return _setupNoticeBox
})();

// Initialize Popup messages
vndTheme.Popups = (function() {
  function Popups(container) {
    this.container = container

    this.selectors = {
      popup_activator: 'vpp-atv', // getElementsByClassName
      popup_box: 'vpp-bx',        // Compare class name
      popup_close: '.vpp-close'   // querySelector
    }

    this.eventHandlers = {};

    this._setupPopups();
    this._setupEventHandlers();
  }

  Popups.prototype = Object.assign({}, Popups.prototype, {
    _setupPopups: function() {
      this.pp_al = this.container.getElementsByClassName(this.selectors.popup_activator); // Popup activator list
    },

    _setupEventHandlers: function() {
      this.eventHandlers.open = this.onPopupOpen.bind(this);
      this.eventHandlers.bodyClick = this._bodyClick.bind(this);
      this.eventHandlers.close = this.closePopups.bind(this);

      Array.from(this.pp_al).forEach(($pp_a) => {
        $pp_a.addEventListener('click', this.eventHandlers.open);
      });
    },

    onPopupOpen: function(e) {
      e.preventDefault();
      const scroll_width = vndTheme.scroll_width + 'px';

      document.body.style.paddingRight = scroll_width;
      document.documentElement.classList.add('vnd-popup-opened');

      var target = e.currentTarget.hash.slice(1);
      this.pp_box = document.getElementById(target);
      this.pp_box.classList.add('active');

      const close_btn = this.pp_box.querySelector(this.selectors.popup_close);
      close_btn.addEventListener('click', this.eventHandlers.close);

      setTimeout(() => {
        document.body.addEventListener('click', this.eventHandlers.bodyClick);
      }, 250);
    },

    closePopups: function(e) {
      e.preventDefault();
      e.stopPropagation();

      this.pp_box.classList.remove('active');

      setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent('vnd_popup:close', {
            bubbles: true,
            cancelable: true
          })
        );
        document.body.removeEventListener('click', this.eventHandlers.bodyClick);
      }, 350);
    },

    _bodyClick: function(e) {
      if (!e.target.classList.contains(this.selectors.popup_box) && !e.target.closest('.' + this.selectors.popup_box)) {
        this.closePopups(e)
      }
    }
  });

  return Popups;
})();

// Initialize Dropdown Elements
vndTheme.Dropdowns = (function() {
  function Dropdowns(container) {
    this.container = container;

    this.selectors = {
      activator: 'dd-pp__atv',      // getElementsByClassName
      wrapper: 'dd-pp__wrp',        // Compare class name
      close: '.dd-pp__close'        // querySelector
    }

    this.eventHandlers = {};

    this._setupDropdowns();
    this._setupEventHandlers();
  }

  Dropdowns.prototype = Object.assign({}, Dropdowns.prototype, {
    _setupDropdowns: function() {
      // Dropdown activator list
      this.dd_al = this.container.getElementsByClassName(this.selectors.activator);
    },

    _setupEventHandlers: function() {
      this.eventHandlers.open = this.onDropdownOpen.bind(this);
      this.eventHandlers.bodyClick = this._bodyClick.bind(this);
      this.eventHandlers.close = this.closeDropdown.bind(this);

      Array.from(this.dd_al).forEach(($dd_a) => {
        $dd_a.addEventListener('click', this.eventHandlers.open);
      });
    },

    onDropdownOpen: function(e) {
      e.preventDefault();
      const $prev = document.querySelector('.dd-pp__wrp.active');
      if ($prev) {
        this._handleClose($prev);
      }

      this.$wrapper = e.currentTarget.parentElement;
      this.$wrapper.classList.add('active');

      const close_btn = this.$wrapper.querySelector(this.selectors.close);
      close_btn && close_btn.addEventListener('click', this.eventHandlers.close);

      setTimeout(() => {
        document.body.addEventListener('click', this.eventHandlers.bodyClick);
      }, 250);
    },

    closeDropdown: function(e) {
      e.preventDefault();
      this._handleClose(this.$wrapper);
      document.body.removeEventListener('click', this.eventHandlers.bodyClick);
    },

    _bodyClick: function(e) {
      if (!e.target.classList.contains(this.selectors.wrapper) &&
          !e.target.closest('.' + this.selectors.wrapper)) {
        this.closeDropdown(e)
      }
    },

    _handleClose: function($el) {
      $el.classList.add('disappearing');
      setTimeout(() => {
        $el.classList.remove('active', 'disappearing');
      }, 350);
    }
  });

  return Dropdowns;
})();

// Initialize functions on window resize
function rszRender() {
  window.onresize = function() {
    initMobileMenu();
    initMobileSidebarMenu();
    vndHeader.initMenuPosition(true);
  }
}

function initScrollTop() {
  var scrolled = false;
  $(window).scroll(function() {
    if ( 250 < $(window).scrollTop() && !scrolled ) {
      $('#toPageTop').addClass('visible');
      scrolled = true;
    }

    if ( 250 > $(window).scrollTop() && scrolled ) {
      $('#toPageTop').removeClass('visible');
      scrolled = false;
    }
  });

  $('#toPageTop').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 'fast');
  })
}

// Search Iframes and convert youtube and vimeos to player
function initIframes(container) {
  const $iframes = container.getElementsByTagName('iframe');
  for (let i = 0; i < $iframes.length; i++) {
    const $el = $iframes[i];
    let videoObj = vndHlp.parseVideo($el.dataset.src);

    const playList = videoObj.id;

    videoObj.id += '?';

    if ( $el.dataset.autoplay == "autoplay" ) {
      videoObj.id += 'autoplay=1&mute=1&';
    }

    if ( $el.dataset.loop == "loop" ) {
      videoObj.id += 'loop=1&playlist=' + playList + '&';
    }

    if ( $el.dataset.controls != "controls" ) {
      videoObj.id += 'controls=0';
    }

    if ( videoObj.type == 'youtube' ) {
      $el.src = '//www.youtube.com/embed/' + videoObj.id;
    } else if ( videoObj.type == 'vimeo' ) {
      $el.src = '//player.vimeo.com/video/' + videoObj.id;
    }
  }
}

var cartPage = {
  initAjaxAddCart() {
    $(document).on('click', 'form .btn-add-cart', function(e) {
      const $addCartBtn = $(e.currentTarget);
      if ( window.vndTpl == 'cart' || $addCartBtn.hasClass('disabled') ) return;
      e.preventDefault();
      const $cartForm = $(this).closest('form'),
            $option = $cartForm.children('.product-actual-select')[0],
            actual_count = parseInt($cartForm.find('.quantity').val());
      let max = 0,
          policy = 'deny',
          inv_mngmt = '';

      if ( $option ) {
        max = parseInt($option.selectedOptions[0].dataset.quantity)
        policy = $option.selectedOptions[0].dataset.policy;
        inv_mngmt = $option.selectedOptions[0].dataset.inventoryManagement;

        if (inv_mngmt != '' && policy != 'continue' && actual_count > max) {
          $cartForm.find('.quantity').val(max);
        }
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $cartForm.serialize(),
        beforeSend: function() {
          $addCartBtn.addClass('disabled vnd-btn-busy');
        },
        success: function(itemData) {
          window.setTimeout(function(){
            $addCartBtn.removeClass('disabled vnd-btn-busy');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              vndHlp.refreshCart(cart);
              if (inv_mngmt != '' && policy != 'continue' && actual_count > max) {
                const desc = vndTheme.lang.cart.set_max_available_html.replace(/<span class=\'max-count\'><\/span>/g, "<span class='max-count'>" + max +" </span>");
                const request = {
                  responseJSON: {
                    message: vndTheme.lang.cart.title,
                    description: desc
                  }
                }
                vndTheme.UserNotice(request, 'info');
              }
            }
          });
        },
        error: function(request) {
          $addCartBtn.removeClass('disabled vnd-btn-busy');
          vndTheme.UserNotice(request, 'error');
        }
      });

      return false;
    });
  },

  initCartPp() {
    $('.cart-dropdown .increase').on('click', function(e) {
      const $data = this.previousElementSibling,
            id = $data.id.replace('cd_ud_', ''),
            qty = parseInt($data.dataset.currentValue) + 1;
      cartPage.changeItQty(id, qty);
    });

    $('.cart-dropdown .reduce').on('click', function(e) {
      const $data = this.nextElementSibling,
            id = $data.id.replace('cd_ud_', ''),
            qty = parseInt($data.dataset.currentValue) - 1;
      cartPage.changeItQty(id, qty);
    });

    const $close = document.querySelector('.cart-dropdown .side-cart__close');
    if ( $close ) {
      $close.addEventListener('click', function(e) {
        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent('vnd_ajx:crt:close', {
            bubbles: true,
            cancelable: true
          })
        );
      });
    }

    const $ts = document.getElementById('CheckoutAgreement');
    if ( $ts ) {
      $ts.addEventListener('change', function(e) {
        if (this.checked) {
          vndHlp.createCookie('vs_tac_agreement', 'true', 1);
        } else {
          vndHlp.eraseCookie('vs_tac_agreement');
        }
      });
    }

    if (vndTheme.enable_ctc) {
      $(document).on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .btn-checkout', function(e) {
        const vs_tac_agreement = vndHlp.readCookie('vs_tac_agreement');
        if (vs_tac_agreement == 'true') {
          return;
        }

        e.preventDefault();
        const res = {
          responseJSON: {
            message: '',
            description: vndTheme.lang.cart.terms_warn
          }
        }
        vndTheme.UserNotice(res, 'warn');
        if (window.vndTpl == 'cart') {
          $('html, body').animate({
            scrollTop: $('.cart-tac').offset().top - 120
          }, 450);
        }

        if (this.classList.contains('shopify-payment-button__button')) {
          document.dispatchEvent(
            new CustomEvent('vnd_ajx:crt:success', {
              bubbles: true,
              cancelable: true
            })
          );
        }

        return false;
      });
    }
  },

  initAjaxRemove() {
    $(document).on("click", ".btn-remove-cart", function(e) {
      e.preventDefault();
      var id = this.dataset.id;
      var $targetItem = $('.btn-remove-cart[data-id="'+ id + '"]').closest('.cart-item');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&id='+id,
        dataType: 'json',
        beforeSend: function() {
          vndHlp.showLoading();
        },
        success: function(t) {
          vndHlp.hideLoading();
          $targetItem.slideUp(350);
          if ( window.vndTpl == 'cart' && t.item_count == 0 ) {
            location.reload();
          }

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              vndHlp.refreshCart(cart);
            }
          });
        },
        error: function(request, textStatus ) {
          vndHlp.hideLoading();
          vndTheme.UserNotice(request, 'error');
        }
      });
    });
  },

  changeItQty(id, qty) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id='+id,
      dataType: 'json',
      beforeSend: function() {
        vndHlp.showLoading();
      },
      success: function(t) {
        vndHlp.hideLoading();

        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            vndHlp.refreshCart(cart);
          }
        });
      },
      error: function(request, textStatus ) {
        vndHlp.hideLoading();
        vndTheme.UserNotice(request, 'error');
      }
    });
  }
}

var blogPage = {
  init() {
    document.querySelectorAll('.blog-section .items-carousel').forEach(function(carousel) {
      initSlider(carousel);
    })
  }
}

var customersPage = {
  customerAddressForm() {
    // Initialize observers on address selectors, defined in shopify_common.js
    if ( Shopify ) {
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('ds-none');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      if ( confirm(confirmMessage || 'Are you sure you wish to delete this address?') ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }
}

var PageRender = {
  init() {
    initMobileMenu();
    initMobileSidebarMenu();
    initSwatch(document.body);
    quickViewInit();
    rszRender();
    vndHlp.ctrVideo();

    if ( vndHlp.isTchDvc() ) {
      $('body').addClass('vnd-device-touch');
    }

    // Save current url for customers to be redirected after login
    var url = window.top.location.href;
    $("#login_redirect").val(url);

    if ( window.vndTpl ) {
      if ( window.vndTpl == 'index' ) {
        initNewsletter();
      }

      if ( window.vndTpl == 'customers/addresses' ) {
        customersPage.customerAddressForm();
      }

      if ( window.vndTpl == 'article' || window.vndTpl == 'blog' ) {
        blogPage.init();
      }
    }

    if ( vndTheme.stt.eb_ajx_crt ) {
      cartPage.initAjaxAddCart();
      cartPage.initCartPp();
      cartPage.initAjaxRemove();
    }

    if ( vndTheme.stt.eb_scrt ) {
      initScrollTop();
    }

    vndHlp.initCookieNotify();

    // Enable wishlist
    vndHlp.wslst();

    // Enable compare list
    vndHlp.cplst();
  }
}

// Register theme events
const vndRgtEvts = function vndRgtEvts() {
  // Ajax Add Cart Success
  document.addEventListener('vnd_ajx:crt:success', this.onAjxCrtScs);
  document.addEventListener('vnd_ajx:crt:close', this.onSdCrtClose);

  // Close popups
  document.addEventListener('vnd_popup:close', this.onPopupClose);

  // Close popups when back button is clicked
  window.addEventListener('popstate', (event) => {
    var mpInstance = $.magnificPopup.instance;
    if ( mpInstance.isOpen ) {
      mpInstance.close();
    }
  });
}

vndRgtEvts.prototype = {
  onAjxCrtScs: function(event) {
    if ( window.vndTpl != 'cart' ) {
      if (vndTheme.stt.ajx_crt_eft == 'sidebar') {
        const scroll_width = vndTheme.scroll_width + 'px';
        $('html').addClass('side-cart-open');
        $('body').css('padding-right', scroll_width);
        $('.sticky-active').css('padding-right', scroll_width + '!important');

        let newPercentage = 0;
        const $newFreeshipProgress = document.querySelector('.vnd-crt__fsa-bar');

        if ($newFreeshipProgress && event.detail) {
          newPercentage = $newFreeshipProgress.style.width;
          $newFreeshipProgress.style.width = event.detail;
          $newFreeshipProgress.classList.add('vnd-crt__fsa-bar--animate');
          setTimeout(() => {
            $newFreeshipProgress.style.width = newPercentage;
          }, 500);
          setTimeout(() => {
            $newFreeshipProgress.classList.remove('vnd-crt__fsa-bar--animate');
          }, 1000);
        }
      } else {
        if ( $('.header.sticky-active').length ) {
          $('.header.sticky-active .cart-dropdown').addClass('active');
        } else {
          $('.cart-dropdown').addClass('active');
        }

        setTimeout(function() {
          $('.cart-dropdown').removeClass('active');
        }, 2500);
      }
    }
  },

  onSdCrtClose() {
    document.documentElement.classList.remove('side-cart-open');
    document.body.style.paddingRight = 0;
  },

  onPopupClose() {
    document.body.style.paddingRight = 0;
    document.documentElement.classList.remove('vnd-popup-opened');
  }
}

// Venedor Theme search functions
var vndSch = (function() {
  let search_tag = '';

  function init() {
    initCategories();
    initPartialSearch();
    if ( vndTheme.sch_pdtv ) {
      initPredictive();
    }

    $(window).on('click touchstart', function(e) {
      if ( $('.search-form.js-hover').length
      && !($(e.target).hasClass('search-form') && $(e.target).hasClass('js-hover'))
      && !$(e.target).parents('.search-form.js-hover').length ) {
        $('.search-form.js-hover').removeClass('js-hover');
      }
    });
  }

  function initCategories(container) {
    const $ctn = container ? container : document.body;
    const ct_a = $ctn.getElementsByClassName('search-by-cat');

    for (let i = 0; i < ct_a.length; i++) {
      const cat = ct_a[i];
      cat.onclick = function(e) {
        e.preventDefault();
        const atv = this.parentElement.previousElementSibling;
        atv.firstChild.innerText = this.innerText;

        if (this.dataset.category) {
          atv.dataset.cat = this.dataset.category;
          search_tag = this.dataset.category;
          search_type = atv.dataset.catType;
        } else {
          atv.dataset.cat = "";
          search_tag = "";
          search_type = "";
        }

        document.dispatchEvent(
          new CustomEvent('vnd_dd:close', {
            bubbles: true,
            cancelable: true
          })
        );
      }
    }
  }

  function initPartialSearch() {
    document.querySelectorAll('.search-form').forEach($form => {
      if (!$form.classList.contains('search-form__with-brand')) {
        $form.addEventListener('submit', runSearch);
      }
    });
  }

  function initPredictive() {
    const $inputs = document.querySelectorAll('.search-input-container input');

    for (let i = 0; i < $inputs.length; i++) {
      const $input = $inputs[i],
            $parent = $input.closest('.search-form'),
            $rs = $parent.querySelector('.result-container');

      if ( $rs ) {
        $input.addEventListener('input', vndHlp.debounce(function(event) {
          event.preventDefault();
          $parent.classList.add('js-hover');
          let term = $input.value;
          if (search_tag) {
            term += '*+' + search_type + ':' + search_tag;
          }

          setSearchResult(term, $rs);
        }, 350));
      }

      $input.onblur = function(e) {
        $parent.classList.remove('js-hover');
      };

      $input.onfocus = function(e) {
        $parent.classList.add('js-hover');
      };
    }
  }

  function setRequestParams(query) {
    return `q=${query}&resources[type]=${vndTheme.pdtv_fd || "product"}&resources[limit]=${vndTheme.sch_lmt || 5}`
  }

  function setSearchResult(query, $rs) {
    if ( query == '' ) {
      $('.result-container').empty();
      return;
    }

    query = setRequestParams(query);
    if ( query ) {
      if (search_tag) {
        query = "/search?section_id=collectionsContent&" + query;

        fetch(query)
        .then(response => response.text())
        .then(result => {
          $rs.innerHTML = result;
        });
      } else {
        fetch(`${vndTheme.routes.predictive_search_url}?section_id=predictive-search&${query}`)
        .then(response => response.text())
        .then(response => {
          $rs.innerHTML = response;
        });
      }
    }
  }

  function runSearch(e) {
    let term = encodeURI(e.target.querySelector('.search-input-container input').value),
    searchPath = '/search',
    type = vndTheme.pdtv_fd || "product",
    constraint = '?';

    if (term.length == 0) {
      e.target.removeEventListener('submit', runSearch);
      return true;
    } else {
      e.preventDefault();
      term += '*';
      const cat = e.currentTarget.querySelector('.search-category-name');

      if ( cat && cat.dataset.cat ) {
        if (cat.dataset.catType) {
          term += '+' + cat.dataset.catType + ':' + cat.dataset.cat;
        } else {
          constraint = '?constraint=' + cat.dataset.cat + '&';
        }
      }

      searchPath += constraint;
      searchPath += type == 'product' ? 'type=product&' : '';
      searchPath += 'q=' + term;
      e.target.removeEventListener('submit', runSearch);
      location = location.origin + searchPath;
    }
  }

  return init;
})();

export {
  initSlider,
  vndHlp,
  vndRgtEvts,
  initProductImageSlider,
  initThumbs,
  initProductImageGrid,
  zoomImage,
  initProductZoomPopup,
  initTabs,
  vndSectionSlider,
  initSizeChart,
  initSwatch,
  quickViewInit,
  groupContent,
  vndIstSection,
  lookbookSection,
  parallaxLookbook,
  vndTopbar,
  vndHeader,
  vndMbHd,
  slideShow,
  vndPkrSt,
  vndMsrGrd,
  vndPageTabs,
  vndServicePromotion,
  vndSectionImage2,
  vndSch,
  PageRender
};
